export default {
    "id": 17597,
    "xmlId": "crm7116",
    "squareKitchen": 17.03,
    "squareTotal": 55.24,
    "squareLiving": 25.41,
    "baseCost": 6430000,
    "costWithDiscount": 6430000,
    "priceAgreement": 4450000,
    "decoration": "Чистовая",
    "roomType": "2 ккв",
    "floor": "9",
    "dateUpdate": "2020-07-28T16:09:56.000Z",
    "clientType": false,
    "status": {
        "id": 1,
        "name": "В продаже",
        "color": "green"
    },
    "dateBooking": false,
    "commission": 250000,
    "commissionPercent": 200000,
    "priceWithoutUnderstating": 6687400,
    "number": "12268",
    "plan": {
        "id": 0,
        "src": "https://crm.1-an.ru/upload/iblock/ee8/7a5d7af6b6c5dedbc95c31717e612a20579c7776.png",
        "size": 0,
        "contentType": "",
        "height": 0,
        "width": 0,
        "empty": false
    },
    "floorPlan": false,
    "gidImg": {
        "id": 0,
        "src": "http://crm.1-an.ru/upload/iblock/b51/Golden-City_01.jpg",
        "size": 0,
        "contentType": "",
        "height": 0,
        "width": 0,
        "empty": false
    },
    "encumbrances": [
        "Рассрочка"
    ],
    "favorite": {
        "inFavorite": false,
        "favoriteId": false,
        "clients": []
    },
    "subway": [
        {
            "id": 459,
            "xmlId": "abc19",
            "name": "Проспект Ветеранов",
            "color": "#d6083b",
            "distanceType": "byTransport",
            "minutes": "20"
        }
    ],
    "note": "<p>\r\n\t Дом сдан, переуступка от физ.лица. В договоре 4450.<br>\r\n</p>\r\n<p>\r\n\t В обременении банка Санкт-Петербург.Окна у кухни-во двор,в комнатах-во двор школы и садика.Отделка \"Шоколад\"\r\n</p>\r\n<p>\r\n <br>\r\n</p>\r\n<br>",
    "photos": [
        "https://crm.1-an.ru/upload/iblock/c99/dbd04f57302a651f442d7334b41021faa177ce44.png"
    ],
    "section": "0",
    "squareBalcony": "0",
    "squareToilet": "0",
    "views": 48,
    "block": {
        "id": 13960,
        "name": "Солнечный город",
        "hideLink": true,
        "about": {
            "advantages": [],
            "previewText": "ЖК Солнечный город - это масштабная квартальная застройка в Красносельском районе СПб. Под строительство комплекса отведен участок площадью 185 га. Здесь будет возведено более 1,3 миллионов кв.м жилья, а также объекты торгово-социальной инфраструктуры. Всего предусмотрено 10 очередей.&#xD;&#xA;&#xD;&#xA;На первом уровне будут размещены и квартиры, и вспомогательные помещения - кладовые, комнаты ТСЖ, посты охраны, колясочные, диспетчерские и прочие. Секции зданий оборудованы мусоропроводами и лифтами. Под каждым домом предусмотрены встроено-пристроенные автостоянки с полумеханизированным типом парковки, в т.ч. на 279 и 247 машиномест в корпусах 2 и 3.&#xD;&#xA;&#xD;&#xA;На эксплуатируемой кровле автостоянок будут организованы зоны отдыха и детские игровые площадки. В кварталах, кроме домов, расположатся также объекты социальной инфраструктуры: 13 детских садов; 5 общеобразовательных школ; детская школа искусств; 2 поликлиники; 2 спорткомплекса с бассейнами; торговые галереи. Одним из ярких элементов жилого комплекса Солнечный город, станет центральный пешеходный бульвар. Длинная извилистая улица соединит между собой разные части микрорайона."
        },
        "photos": {
            "complex": [
                {
                    "id": 294797,
                    "src": "/upload/iblock/9dc/wm_e5ab1ad21a90204f75eab417ab2283e3.jpg",
                    "contentType": "image/jpeg",
                    "width": 1280,
                    "height": 853,
                    "description": ""
                },
                {
                    "id": 294798,
                    "src": "/upload/iblock/007/wm_a89d7e00feb2ab0a637e01959c251bc0.jpg",
                    "contentType": "image/jpeg",
                    "width": 1280,
                    "height": 853,
                    "description": ""
                },
                {
                    "id": 294799,
                    "src": "/upload/iblock/707/wm_604d9ec8838763ffb97429d8d7f301c2.jpg",
                    "contentType": "image/jpeg",
                    "width": 1280,
                    "height": 853,
                    "description": ""
                },
                {
                    "id": 294800,
                    "src": "/upload/iblock/a10/wm_0988dfca74bbb265f15abf4f1999bb0e.jpg",
                    "contentType": "image/jpeg",
                    "width": 1138,
                    "height": 758,
                    "description": ""
                },
                {
                    "id": 294801,
                    "src": "/upload/iblock/b82/wm_bcf02641a0a8d061c0882f4b0bb01d23.jpg",
                    "contentType": "image/jpeg",
                    "width": 1202,
                    "height": 801,
                    "description": ""
                },
                {
                    "id": 294802,
                    "src": "/upload/iblock/de7/wm_9a4a8bb505f636e61df501e8a5b7fece.jpg",
                    "contentType": "image/jpeg",
                    "width": 1280,
                    "height": 853,
                    "description": ""
                },
                {
                    "id": 21678,
                    "src": "/upload/iblock/447/СГ_4.jpg",
                    "contentType": "image/jpeg",
                    "width": 1508,
                    "height": 1066,
                    "description": ""
                },
                {
                    "id": 21676,
                    "src": "/upload/iblock/d01/СГ_2.jpg",
                    "contentType": "image/jpeg",
                    "width": 1508,
                    "height": 1066,
                    "description": ""
                },
                {
                    "id": 21677,
                    "src": "/upload/iblock/1dd/СГ_6.jpg",
                    "contentType": "image/jpeg",
                    "width": 1508,
                    "height": 1066,
                    "description": ""
                }
            ],
            "decorationRaw": [
                {
                    "id": 511881,
                    "src": "/upload/iblock/4bc/chernovaya_otdelka.jpg",
                    "contentType": "image/jpeg",
                    "width": 1600,
                    "height": 900,
                    "description": ""
                }
            ],
            "decorationPreFinish": [],
            "decorationFinish": [
                {
                    "id": 71124,
                    "src": "/upload/resize_cache/iblock/597/1920_1080_140cd750bba9870f18aada2478b24840a/Ваниль_1.jpg",
                    "contentType": "image/jpeg",
                    "width": 1698,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71125,
                    "src": "/upload/resize_cache/iblock/08d/1920_1080_140cd750bba9870f18aada2478b24840a/Ваниль_2.jpg",
                    "contentType": "image/jpeg",
                    "width": 1531,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71126,
                    "src": "/upload/resize_cache/iblock/caf/1920_1080_140cd750bba9870f18aada2478b24840a/Ваниль_3.jpg",
                    "contentType": "image/jpeg",
                    "width": 1480,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71127,
                    "src": "/upload/resize_cache/iblock/5e3/1920_1080_140cd750bba9870f18aada2478b24840a/Ваниль_4.jpg",
                    "contentType": "image/jpeg",
                    "width": 1440,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71128,
                    "src": "/upload/resize_cache/iblock/208/1920_1080_140cd750bba9870f18aada2478b24840a/Ваниль_Луиза_1.jpg",
                    "contentType": "image/jpeg",
                    "width": 967,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71129,
                    "src": "/upload/resize_cache/iblock/cf6/1920_1080_140cd750bba9870f18aada2478b24840a/Шоколад_1.jpg",
                    "contentType": "image/jpeg",
                    "width": 1570,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71130,
                    "src": "/upload/resize_cache/iblock/7a1/1920_1080_140cd750bba9870f18aada2478b24840a/Шоколад_2.jpg",
                    "contentType": "image/jpeg",
                    "width": 1440,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71131,
                    "src": "/upload/resize_cache/iblock/05a/1920_1080_140cd750bba9870f18aada2478b24840a/Шоколад_3.jpg",
                    "contentType": "image/jpeg",
                    "width": 1440,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71132,
                    "src": "/upload/resize_cache/iblock/783/1920_1080_140cd750bba9870f18aada2478b24840a/Шоколад_4.jpg",
                    "contentType": "image/jpeg",
                    "width": 1440,
                    "height": 1080,
                    "description": ""
                },
                {
                    "id": 71133,
                    "src": "/upload/resize_cache/iblock/a07/1920_1080_140cd750bba9870f18aada2478b24840a/Шоколад_Диана_1.jpg",
                    "contentType": "image/jpeg",
                    "width": 1439,
                    "height": 1080,
                    "description": ""
                }
            ]
        },
        "aeroPanorama": "https://pano.3bita.ru/solnechnyj_gorod/",
        "banks": [
            {
                "id": "26923",
                "logo": {
                    "id": 410968,
                    "src": "/upload/resize_cache/iblock/800/300_50_140cd750bba9870f18aada2478b24840a/13d8c3ef303bc3c29cd39527c770d234.png",
                    "contentType": "image/png",
                    "width": 225,
                    "height": 50,
                    "description": ""
                },
                "name": "Росбанк ДОМ",
                "xmlId": "abc91",
                "bankPrograms": [
                    {
                        "id": 1151,
                        "name": "Новостройка",
                        "xmlId": "abc73478707-9e5a-4de0-ad9e-4538a3bba41e",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 70,
                        "creditMin": 600000,
                        "creditMax": 30000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 20,
                        "maleAgeMax": 64,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 64,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Список документов:<br/>1) Копия паспорта<br/>2) Документы, подтверждающие доход (справка по форме 2НДФЛ или справка по форме Банка). Для владельцев бизнеса <br/>— налоговые декларации, в зависимости от системы налогообложения, установленные законодательством, и управленческая отчетность; 3) Копия трудовой книжки, заверенная работодателем (все заполненные страницы), для <br/>военнослужащих справка по установленной форме.<br/><br/>Надбавки к ставкам: <br/>1) Для собственников бизнеса и индивидуальных предпринимателей –процентная ставка выше базовой величины на 1,25%. <br/>2) При подтверждении части дохода по форме Банка процентная  ставка  выше базовой величины на 0,5%. <br/>3) при выборе программы, не предусматривающей страхование риска причинения вреда жизни и потери трудоспособности, процентная ставка по кредиту выше базовой величины на 1,5%<br/>4) Для собственников бизнеса и индивидуальных предпринимателей, доход которыхподтверждается справкой по форме 2-НДФЛ или налоговой декларацией –процентная ставка выше базовой величины на 0,75%. Для собственников бизнеса и индивидуальных предпринимателей, доход которых подтверждается бухгалтерской, налоговой и иной финансовой отчетностью –процентная ставка выше базовой величины на 1,25%<br/> 5) при выборе программы, не предусматривающей страхование риска прекращения права собственности на квартиру, обременения (ограничения) права собственности на квартиру правами третьих лиц, процентная ставка по кредиту выше базовой величины на 1%; <br/>6) при выборе программы, не предусматривающей страхование рисков утраты и повреждения недвижимого имущества, процентная ставка по кредиту выше базовой величины на 1,5%. <br/><br/>Клиент может воспользоваться программой Назначь свою ставку <br/>1) оптима (минус 0,5% к ставке)- стоимость 1% от СК (но не менее 10500) <br/>2) медиа  (минус 1% к ставке)- стоимость 2,5% от СК (но не менее 10500) <br/>3) ультра  (минус 1,5% к ставке)- стоимость 4% от СК (но не менее 10500). В от 5% при наличиии мат капитала. <br/><br/>Для Зарплатников ставки: ПВ от 15% - ставка 9,64%, ПВ от 20% - ставка 9,39%, для тех кто ранее брал кредит есть допонительные скидки",
                        "minPercent": 9.89,
                        "maxPercent": 10.75,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1234,
                        "name": "Госпрограмма для семей с детьми",
                        "xmlId": "abc9711ebb7-055c-4d85-b6b3-180b9810de59",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 600000,
                        "creditMax": 12000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 20,
                        "maleAgeMax": 64,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 64,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Список документов:<br/>1) Копия паспорта<br/>2) Документы, подтверждающие доход (справка по форме 2НДФЛ или справка по форме Банка). Для владельцев бизнеса <br/>— налоговые декларации, в зависимости от системы налогообложения, установленные законодательством, и управленческая отчетность; 3) Копия трудовой книжки, заверенная работодателем (все заполненные страницы), для <br/>военнослужащих справка по установленной форме.<br/><br/>В программе могут участвовать семьи, в которых с 1 января 2018 года и до 31 декабря 2022 года родился второй и/или последующий ребенок. При этом заемщик и дети, с рождением которых появилось право на господдержку, должны иметь гражданство РФ.Оформить кредит по ставке 4,69% могут как новые, так и действующие клиенты Росбанк при соответствии условиям программы<br/><br/>Ставка  4,35% для зарплатных клиентов!",
                        "minPercent": 4.65,
                        "maxPercent": 4.65,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1235,
                        "name": "Льгоьная Новостройка",
                        "xmlId": "abc3c934d79-e106-4ed5-b780-2c2b81c908c7",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 600000,
                        "creditMax": 8000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 20,
                        "maleAgeMax": 64,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 64,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "При отсутствии хотя бы одного из видов страхования (страхования риска причинения вреда жизни и потери трудоспособности и/или утраты и повреждения недвижимого имущества) Банк вправе увеличить процентную ставку по кредиту на 1%.<br/><br/>для Зарплатных клиентов ставка 3,2%!",
                        "minPercent": 3.5,
                        "maxPercent": 3.5,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1252,
                        "name": "На апартаменты",
                        "xmlId": "abce5fc6481-38d3-4700-bebe-2cdf4f320374",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 600000,
                        "creditMax": 12000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 20,
                        "maleAgeMax": 64,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 64,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "",
                        "minPercent": 6.14,
                        "maxPercent": 6.14,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1256,
                        "name": "Новостройка",
                        "xmlId": "abcd0f7d5b3-c53b-4bc8-b4b0-5f4cdafd68e4",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 80,
                        "creditMin": 600000,
                        "creditMax": 3000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 20,
                        "maleAgeMax": 64,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 64,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Список документов:<br/>1) Копия паспорта<br/>2) Документы, подтверждающие доход (справка по форме 2НДФЛ или справка по форме Банка). Для владельцев бизнеса <br/>— налоговые декларации, в зависимости от системы налогообложения, установленные законодательством, и управленческая отчетность; 3) Копия трудовой книжки, заверенная работодателем (все заполненные страницы), для <br/>военнослужащих справка по установленной форме. ПВ от 5% при  наличии  Государственного  сертификата  на  материнский  (семейный) капитал (при приобретении квартиры).При этом остаток средств по сертификату не может уменьшать размер стандартного первоначального взноса более чем на 10% от стоимости приобретаемого жилья.<br/><br/>Надбавки к ставкам: <br/>1) Для собственников бизнеса и индивидуальных предпринимателей –процентная ставка выше базовой величины на 1,25%. <br/>2) При подтверждении части дохода по форме Банка процентная  ставка  выше базовой величины на 0,5%. <br/>3) при выборе программы, не предусматривающей страхование риска причинения вреда жизни и потери трудоспособности, процентная ставка по кредиту выше базовой величины на 1,5% <br/>4) Для собственников бизнеса и индивидуальных предпринимателей, доход которыхподтверждается справкой по форме 2-НДФЛ или налоговой декларацией –процентная ставка выше базовой величины на 0,75%. Для собственников бизнеса и индивидуальных предпринимателей, доход которых<br/>подтверждается бухгалтерской, налоговой и иной финансовой отчетностью –процентная ставка выше базовой величины на 1,25% <br/>5) при выборе программы, не предусматривающей страхование риска прекращения права собственности на квартиру, обременения (ограничения) права собственности на квартиру правами третьих лиц, процентная ставка по кредиту выше базовой величины на 1%;<br/> 6) при выборе программы, не предусматривающей страхование рисков утраты и повреждения недвижимого имущества, процентная ставка по кредиту выше базовой величины на 1,5%.<br/><br/> Клиент может воспользоваться программой Назначь свою ставку 1) оптима (минус 0,5% к ставке)- стоимость 1% от СК (но не менее 10500) 2) медиа  (минус 1% к ставке)- стоимость 2,5% от СК (но не менее 10500) 3) ультра  (минус 1,5% к ставке)- стоимость 4% от СК (но не менее 10500). В от 5% при наличиии мат капитала. Для Зарплатников ставки: ПВ от 15% - ставка 9,64%, ПВ от 20% - ставка 9,39%, для тех кто ранее брал кредит есть допонительные скидки",
                        "minPercent": 9.39,
                        "maxPercent": 9.39,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 3.5,
                "maxPeriod": 25,
                "minInitialPayment": 20,
                "formName": "Аккредитация Росбанк ДОМ в Солнечный город"
            },
            {
                "id": "11869",
                "logo": {
                    "id": 411034,
                    "src": "/upload/resize_cache/iblock/1ae/300_50_140cd750bba9870f18aada2478b24840a/upld_489.jpg",
                    "contentType": "image/jpeg",
                    "width": 95,
                    "height": 50,
                    "description": ""
                },
                "name": "ПромСвязьБанк",
                "xmlId": "abc12",
                "bankPrograms": [
                    {
                        "id": 1152,
                        "name": "Семейная ипотека",
                        "xmlId": "abc29dfaf45-22e9-4d15-9fb6-4bf0ced42b15",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 24,
                        "requirements": "Выдача кредитов в рамках Госпрограммы  возможна не позднее 31.12.22 (включительно).<br/><br/>Лица, имеющие право на получение кредита в рамках Госпрограммы: - Граждане РФ, у которых родился второй или третий ребенок в период с 01.01.2018 по 31.12.2022 г. (включительно), имеющий гражданство РФ. <br/><br/>Ставка 6%  <br/>1) В течение 3 лет с даты выдачи кредита в связи с рождением второго ребенка <br/>2) В течение 5 лет с даты выдачи кредита в связи с рождением третьего ребенка. при отказе заемщика от возобновления действия/расторжении договора страхования жизни годовая процентная ставка по кредиту будет увеличена до максимально допустимого в рамках Программы кредитования размера процентной ставки, а именно: ключевая ставка ЦБ РФ на дату выдачи кредита + 2 п.п. <br/><br/>Надбавки:<br/>? в случае выбора Заемщиком условий кредитования без страхования/ ненадлежащего исполнения обязанностей по страхованию процентная ставка<br/>увеличивается на 5 процентных пункта;<br/>? в случае возникновения в Период субсидирования просроченной задолженности по основному долгу и/или по процентам процентная ставка<br/>устанавливается в размере ключевой ставки Банка России, установленной на дату заключения Кредитного договора, увеличенной на 2 процентных<br/>пункта",
                        "minPercent": 3.99,
                        "maxPercent": 9.25,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1166,
                        "name": "Военная ипотека",
                        "xmlId": "abc1765c62c-11c8-47dc-acc3-6c50f548ca4f",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 700000,
                        "creditMax": 3286000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 50,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 50,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 36,
                        "requirements": "Кредит предоставляется военнослужащим участникам накопительно-ипотечной системы, имеющим право на получение целевого жилищного займа на основании Федерального закона «О накопительно-ипотечной системе жилищного обеспечения военнослужащих» №117-ФЗ от 20.08.2004г",
                        "minPercent": 7.4,
                        "maxPercent": 7.4,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1178,
                        "name": "Новостройка (2 док-та)",
                        "xmlId": "abc178d9ad5-9ee2-4a4c-86c8-88cb4e252503",
                        "initialPaymentMin": 40,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 24,
                        "requirements": " Размеры процентных ставок указаны с присоединением к Договору коллективного страхования  (ДКС) и с индивидуальным страхованием (ИС).<br/><br/>Надбавки к процентной ставке: <br/>1) в случае выбора Заемщиком условий кредитования без страхования/ ненадлежащего исполнения обязанностей по страхованию процентная ставка увеличивается на 3 процентных пункта;<br/>2) в случае отсутствия регистрации права собственности Покупателя на Квартиру и ипотеки в пользу Банка после истечения 12 (двенадцати) календарных месяцев с планируемой даты ввода многоквартирного дома в эксплуатацию, указанной в Договоре о приобретении Предмета залога,действующая процентная ставка увеличивается на 1,5 процентных пункта до предоставления документов, свидетельствующих о регистрации права<br/>собственности Покупателя на Квартиру и ипотеки в пользу Банка; <br/>3)  в случае наличия одновременно нескольких оснований для применения надбавок и(или) дисконтов соответствующие надбавки и(или) дисконты суммируются<br/><br/>В рамках предложения «Экспресс ипотека» Заемщик может быть наемным работником, индивидуальным предпринимателем, учредителем (участником) юридического лица (товарищества, общества, кооператива). <br/><br/>для клиентов, получающих заработную плату с использованием международных банковских карт, эмитированных Банком, при размере первоначального взноса 40-80%<br/>(включая оба значения) процентная ставка – 10,9%",
                        "minPercent": 11,
                        "maxPercent": 11,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1207,
                        "name": "Новостройка ПВ 0%",
                        "xmlId": "abc9bb6fae9-fb53-491d-acc8-ce4bc269bec0",
                        "initialPaymentMin": 0,
                        "initialPaymentMax": 100,
                        "creditMin": 500000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 24,
                        "requirements": "Надбавки в случае выбора Заемщиком условий кредитования без страхования процентная ставка увеличивается на 6%.<br/><br/> Список документов: <br/>1) Паспорт РФ <br/>2) СНИЛС <br/>3) Документ, подтверждающий семейное положение <br/>4) Документы, подтверждающие трудовую деятельность Заемщика/Созаемщика (при наличии)/Поручителя (при наличии), доход которых учитывается при расчете суммы кредита.<br/>5) Документы, подтверждающие доход Заемщика/Созаемщика (при наличии)/Поручителя (при наличии), доход которых учитывается при расчете суммы кредита. <br/>6) Для Поручителей, доход которых учитывается при расчете суммы Кредита: документы, подтверждающие родственные связи с Заемщиком и/или Созаемщиком.<br/>7) Для мужчин (Заемщика/Созаемщик (при наличии)/Поручителя (при наличии) до 27 лет предоставляется военный билет и/или иные документы, свидетельствующие о том, что лицо не подлежит призыву на военную службу. <br/><br/>• для клиентов, получающих заработную плату с использованием международных банковских карт, эмитированных Банком, процентная ставка – 11,6%",
                        "minPercent": 12.1,
                        "maxPercent": 12.1,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1212,
                        "name": "Новостройка для ключевых застройщиков 2",
                        "xmlId": "abc258b2479-970e-4327-94fa-d4cda0a3fcb7",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 24,
                        "requirements": "Надбавки в случае выбора Заемщиком условий кредитования без страхования процентная ставка увеличивается на 6%.<br/><br/> Список документов: <br/>1) Паспорт РФ <br/>2) СНИЛС <br/>3) Документ, подтверждающий семейное положение <br/>4) Документы, подтверждающие трудовую деятельность Заемщика/Созаемщика (при наличии)/Поручителя (при наличии), доход которых учитывается при расчете суммы кредита.<br/>5) Документы, подтверждающие доход Заемщика/Созаемщика (при наличии)/Поручителя (при наличии), доход которых учитывается при расчете суммы кредита. <br/>6) Для Поручителей, доход которых учитывается при расчете суммы Кредита: документы, подтверждающие родственные связи с Заемщиком и/или Созаемщиком.<br/>7) Для мужчин (Заемщика/Созаемщик (при наличии)/Поручителя (при наличии) до 27 лет предоставляется военный билет и/или иные документы, свидетельствующие о том, что лицо не подлежит призыву на военную службу. <br/><br/>",
                        "minPercent": 9.8,
                        "maxPercent": 9.95,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1217,
                        "name": "Новостройка",
                        "xmlId": "abc472dcd39-9124-4f06-9bf1-e326a7efed58",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 24,
                        "requirements": " Размеры процентных ставок указаны с присоединением к Договору коллективного страхования  (ДКС) и с индивидуальным страхованием (ИС).<br/><br/>Надбавки к процентной ставке: <br/>1) в случае выбора Заемщиком условий кредитования без страхования/ ненадлежащего исполнения обязанностей по страхованию процентная ставка увеличивается на 3 процентных пункта;<br/>2) в случае отсутствия регистрации права собственности Покупателя на Квартиру и ипотеки в пользу Банка после истечения 12 (двенадцати) календарных месяцев с планируемой даты ввода многоквартирного дома в эксплуатацию, указанной в Договоре о приобретении Предмета залога,действующая процентная ставка увеличивается на 1,5 процентных пункта до предоставления документов, свидетельствующих о регистрации права<br/>собственности Покупателя на Квартиру и ипотеки в пользу Банка;<br/>3)  в случае наличия одновременно нескольких оснований для применения надбавок и(или) дисконтов соответствующие надбавки и(или) дисконты суммируются. <br/><br/>Список документов: <br/>1) Паспорт РФ <br/>2)СНИЛС <br/>3)Документ, подтверждающий семейное положение <br/>4)Документы, подтверждающие трудовую деятельность Заемщика/Созаемщика (при наличии)/Поручителя (при наличии), доход которых учитывается при расчете суммы кредита. <br/>5) Документы, подтверждающие доход Заемщика/Созаемщика (при наличии)/Поручителя (при наличии), доход которых учитывается при расчете суммы кредита<br/>6) Для Поручителей, доход которых учитывается при расчете суммы Кредита: документы, подтверждающие родственные связи с Заемщиком и/или Созаемщиком<br/>7) Для мужчин (Заемщика/Созаемщик (при наличии)/Поручителя (при наличии) до 27 лет предоставляется военный билет и/или иные документы, свидетельствующие о том, что лицо не подлежит призыву на военную службу. <br/><br/>Минимальный мат капитал 100 тыс. <br/><br/>Для ИП - стаж от 2-х лет. <br/><br/> Для ЗП клиентов стака 7,7%<br/><br/>",
                        "minPercent": 8.5,
                        "maxPercent": 10.75,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1241,
                        "name": "Госпрограмма 2020",
                        "xmlId": "abc051fd1b5-5102-439d-aacf-96a418d07dbe",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 24,
                        "requirements": "Надбавки к процентной ставке  <br/>+1% — при отказе от страхования жизни и здоровья заемщика, а также страхование имущества в соответствии с требованиями Банка. <br/>Срок действия до по 1 ноября 2020 (включительно)<br/><br/>",
                        "minPercent": 5.85,
                        "maxPercent": 5.85,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1255,
                        "name": "Военная ипотека Господдержка",
                        "xmlId": "abc739274e7-6f06-470c-b307-502c41016334",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 80,
                        "creditMin": 700000,
                        "creditMax": 3790000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 50,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 50,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 36,
                        "requirements": "Кредит предоставляется военнослужащим участникам накопительно-ипотечной системы, имеющим право на получение целевого жилищного займа на основании Федерального закона «О накопительно-ипотечной системе жилищного обеспечения военнослужащих» №117-ФЗ от 20.08.2004г",
                        "minPercent": 5.85,
                        "maxPercent": 5.85,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 3.99,
                "maxPeriod": 25,
                "minInitialPayment": 20,
                "formName": "Аккредитация ПромСвязьБанк в Солнечный город"
            },
            {
                "id": "11854",
                "logo": {
                    "id": 411000,
                    "src": "/upload/resize_cache/iblock/50e/300_50_140cd750bba9870f18aada2478b24840a/7576517c161ecec9365adbd8b3fc1865.jpg",
                    "contentType": "image/jpeg",
                    "width": 108,
                    "height": 50,
                    "description": ""
                },
                "name": "АК Барс Банк",
                "xmlId": "abc31",
                "bankPrograms": [
                    {
                        "id": 1125,
                        "name": "АК Барс-Перпесктива",
                        "xmlId": "abcb6099dd0-7977-4612-92f9-0216a3b7ca47",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 15000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 3,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "При Сумме кредита более  10 млн ставки ПВ от 20% - ставка 10,2%<br/><br/>Требования к заемщику:<br/>• гражданство РФ, постоянная или временная на территории РФ <br/>• возраст заемщика от 18 до 70 лет (на момент окончательного погашения ипотечного кредита)  <br/>• общий трудовой стаж и стаж на последнем месте работы не менее 3 месяцев<br/><br/>Дополнительные требования в случае, если заемщик ИП:<br/>• ИП существует не менее 1 года  <br/>• ПВ от 20% <br/>• максимальная сумма кредита 15 млн<br/><br/>Пакет документов для физ. лица:<br/>1. Паспорт <br/>2. Водительское удостоверение либо страховое свидетельство о государственном пенсионном страховании <br/>3. Справка о ЗП, копия ТК не нужна (если ПВ менее 40%)<br/>При наличии: <br/>   • копия военного билета для лиц мужского пола призывного возраста (до 27 лет) <br/>   • свидетельство о браке и документы, идентифицирующие личность супруга. <br/><br/>Для ИП дополнительные документы:<br/>• технико-экономическое обоснование сделки (во вложении)<br/>• свидетельство о регистрации ИП<br/>• лицензия (если деятельность подлежит лицензированию).<br/><br/>Дополнительные документы, предоставляемые Собственником бизнеса:<br/>• выписка из ЕГРЮЛ сроком действия не более 30 (тридцати) календарных дней с даты выдачи уполномоченным органом.<br/>• оригиналы лицензий, сертификатов, патентов (если предусмотрено законодательством)<br/>• приказ  о возложении  обязанностей  по  ведению бухгалтерского учета  на руководителя  (предоставляется  в случае отсутствия  в штате  организации должности главного  бухгалтера)<br/><br/>Указанные процентные ставки устанавливаются при условии наличия страхового обеспечения в виде заключенных и оплаченных:<br/>1) договора страхования жизни Заемщиков и страхования Заемщиков от несчастных случаев и болезней (личное страхование); <br/>2) договора страхования Предмета ипотеки от гибели и повреждения (имущественное страхование) (необходимо после завершения строительства).<br/><br/>В качестве Первого взноса возможет мат капитал. <br/><br/> Надбавки к процентной ставке: <br/>1) При не пролонгации или несвоевременной пролонгации заемщиком договора имущественного страхования, процентная ставка по кредитному договору повышается на 1%.<br/> 2) При отсутствии страхового обеспечения в виде личного страхования Заемщиков (страхование жизни и потери трудоспособности заемщика) от несчастных случаев и болезней, соответствующий размер процентной ставки увеличивается на 1%. <br/>3) Для ИП,собственников бизнеса - ставка выше на 1%. При первоначальном взносе по кредиту от 50% предусмотрена возможность рассмотрения выдачи ипотечного кредитного сертификата  без документа подтверждающего доход Заемщика, при условии его последующего предоставления одновременно с документами по Объекту недвижимости.. Данная возможность не применяется для Заемщика зарегистрированного в качестве  ИП/СБ. <br/>4) для ЗП клиентов ставка 8,7% (приПВ от 20%) 5) при приобретении жилья у компагий - партнеров ставка 8,9% (при ПВ от 20%) 6) при приобретении квартиры более 100метров кв. ставка 8,5% (при ПВ от 20%). <br/><br/>ПВ от 10% только для держателей «зарплатной» карты банка<br/><br/>При первоначальном взносе по кредиту от 50% предусмотрена возможность рассмотрения выдачи ипотечного кредитного сертификата  без документа подтверждающего доход Заемщика, при условии его последующего предоставления одновременно с документами по Объекту недвижимости.",
                        "minPercent": 8.7,
                        "maxPercent": 8.9,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1177,
                        "name": "Господдержка для семей с детьми",
                        "xmlId": "abc8efd51c8-7284-4cd3-b3ed-84c67085da54",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 8000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 3,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Требования к заемщику:<br/>• гражданство РФ, постоянная или временная на территории РФ <br/>• возраст заемщика от 18 до 70 лет (на момент окончательного погашения ипотечного кредита)  <br/>• общий трудовой стаж и стаж на последнем месте работы не менее 3 месяцев<br/><br/>Пакет документов для физ. лица:<br/>1. Паспорт <br/>2. Водительское удостоверение либо страховое свидетельство о государственном пенсионном страховании <br/>3. Справка о ЗП, копия ТК не нужна (если ПВ менее 40%)<br/>При наличии: <br/>   • копия военного билета для лиц мужского пола призывного возраста (до 27 лет) <br/>   • свидетельство о браке и документы, идентифицирующие личность супруга. <br/><br/>Выдача кредитов в рамках Госпрограммы  возможна не позднее 31.12.22 (включительно).<br/>Лица, имеющие право на получение кредита в рамках Госпрограммы: - Граждане РФ, у которых родился второй или третий ребенок в период с 01.01.2018 по 31.12.2022 г. (включительно), имеющий гражданство РФ. <br/><br/>Льготная ставка действует на весь срок кредитования<br/>До регистрации ипотеки в пользу банка (при рефинансировании кредита) действует следующая процентная ставка: ключевая ставка ЦБ РФ на дату выдачи кредита + 4%",
                        "minPercent": 4.5,
                        "maxPercent": 9.5,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1231,
                        "name": "\"Зимняя сказка\" до 29.02.2020",
                        "xmlId": "abc82285e05-416a-4e50-9a90-30c004e2f3f2",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 15000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 3,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "При Сумме кредита более  10 млн ставки ПВ от 20% - ставка 10,2%<br/><br/>Требования к заемщику:<br/>• гражданство РФ, постоянная или временная на территории РФ <br/>• возраст заемщика от 18 до 70 лет (на момент окончательного погашения ипотечного кредита)  <br/>• общий трудовой стаж и стаж на последнем месте работы не менее 3 месяцев<br/><br/>Дополнительные требования в случае, если заемщик ИП:<br/>• ИП существует не менее 1 года  <br/>• ПВ от 20% <br/>• максимальная сумма кредита 15 млн<br/><br/>Пакет документов для физ. лица:<br/>1. Паспорт <br/>2. Водительское удостоверение либо страховое свидетельство о государственном пенсионном страховании <br/>3. Справка о ЗП, копия ТК не нужна (если ПВ менее 40%)<br/>При наличии: <br/>   • копия военного билета для лиц мужского пола призывного возраста (до 27 лет) <br/>   • свидетельство о браке и документы, идентифицирующие личность супруга. <br/><br/>Для ИП дополнительные документы:<br/>• технико-экономическое обоснование сделки (во вложении)<br/>• свидетельство о регистрации ИП<br/>• лицензия (если деятельность подлежит лицензированию).<br/><br/>Дополнительные документы, предоставляемые Собственником бизнеса:<br/>• выписка из ЕГРЮЛ сроком действия не более 30 (тридцати) календарных дней с даты выдачи уполномоченным органом.<br/>• оригиналы лицензий, сертификатов, патентов (если предусмотрено законодательством)<br/>• приказ  о возложении  обязанностей  по  ведению бухгалтерского учета  на руководителя  (предоставляется  в случае отсутствия  в штате  организации должности главного  бухгалтера)<br/><br/>Указанные процентные ставки устанавливаются при условии наличия страхового обеспечения в виде заключенных и оплаченных:<br/>1) договора страхования жизни Заемщиков и страхования Заемщиков от несчастных случаев и болезней (личное страхование); <br/>2) договора страхования Предмета ипотеки от гибели и повреждения (имущественное страхование) (необходимо после завершения строительства).<br/><br/>В качестве Первого взноса возможет мат капитал. <br/><br/>Надбавки к процентной ставке: <br/>1) При не пролонгации или несвоевременной пролонгации заемщиком договора имущественного страхования, процентная ставка по кредитному договору повышается на 1%. <br/>2) При отсутствии страхового обеспечения в виде личного страхования Заемщиков (страхование жизни и потери трудоспособности заемщика) от несчастных случаев и болезней, соответствующий размер процентной ставки увеличивается на 1%. <br/>3) Для ИП\\собственника бизнеса- ставка выше на 0,5%. 4) для ЗП клиентов ставка 8,8% (приПВ от 20%) <br/>5) при приобретении жилья у компагий - партнеров ставка 9% (при ПВ от 20%) <br/>6) при приобретении квартиры более 100метров кв. ставка 8,7% (при ПВ от 20%)<br/><br/>При первоначальном взносе по кредиту от 50% предусмотрена возможность рассмотрения выдачи ипотечного кредитного сертификата  без документа подтверждающего доход Заемщика, при условии его последующего предоставления одновременно с документами по Объекту недвижимости.. Данная возможность не применяется для Заемщика зарегистрированного в качестве  ИП/СБ.",
                        "minPercent": 7.99,
                        "maxPercent": 7.99,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1245,
                        "name": "Госпрограмма 2020",
                        "xmlId": "abc802fb132-423f-49ab-b681-e595da6bb897",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 8000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 3,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "При отказе от присоединения к договору коллективного страхования ставка 7,2%",
                        "minPercent": 6.2,
                        "maxPercent": 6.2,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    }
                ],
                "minPercent": 4.5,
                "maxPeriod": 30,
                "minInitialPayment": 25,
                "formName": "Аккредитация АК Барс Банк в Солнечный город"
            },
            {
                "id": "11855",
                "logo": {
                    "id": 411002,
                    "src": "/upload/resize_cache/iblock/c66/300_50_140cd750bba9870f18aada2478b24840a/e03221cb79cec25baffcab23b234b55b.jpg",
                    "contentType": "image/jpeg",
                    "width": 152,
                    "height": 50,
                    "description": ""
                },
                "name": "Банк Возрождение",
                "xmlId": "abc21",
                "bankPrograms": [
                    {
                        "id": 1191,
                        "name": "Господдержка для семей с детьми",
                        "xmlId": "abccf090502-91be-4800-b87c-9e6a179a4630",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "Указанные процентные ставки действуют при личном и имущественном страховании способом присоединения к Договору комплексного страхования. При заключении Индивидуального договора личного и имущественного страхования процентная ставка увеличивается на 0,50 процентных пункт. При отсутствии страхования любым способом процентная ставка увеличивается на 3 процентных пункта.",
                        "minPercent": 4.5,
                        "maxPercent": 9.25,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1196,
                        "name": "Новостройка",
                        "xmlId": "abcfb38903a-9682-4cdc-84ca-b087fd0ec415",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 60000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "СТАВКИ указаны при сумме кредита от 5 млн рубл. При сумме кредита до 3 млн руб, ставки: ПВ от 10% - 8,45%, ПВ от 20% - 9,35%, При сумме кредита от 3 до  5 млн руб, ставки: ПВ от 10% - 8,2%, ПВ от 20% - 9,1%.<br/><br/>Стаж на последнем месте работы не менее 6 месяцев для наемных работников (не менее 3 месяцев при условии увольнения с предыдущего места работы и зачисления на новое место без прерывания трудового стажа и с увеличением уровня доходов), не менее 2 лет — для индивидуальных предпринимателей, лиц, занимающихся частной практикой, владельцев бизнеса. <br/><br/> • Справка по форме 2-НДФЛ, заверенная должным образом не требуется для: сотрудников Банка, участников «зарплатного проекта» Банка «Возрождение» (ПАО), ПАО «Промсвязьбанк», Сбербанка, ВТБ, Россельхозбанка, Газпромбанка,, зарплата которых полностью или в части, достаточной для получения кредитного продукта, проходит через СКС, а также для индивидуальных предпринимателей, владельцев бизнеса). <br/><br/>Список документов во вложении.  Максимум — 3 созаемщика (включая основного). <br/><br/>Платежи (ежегодные) за сбор, обработку и техническую передачу информации о физическом лице, связанную с распространением на него условий Договора ипотечного страхования, а также за распространение на него условий Договора ипотечного страхования из расчета:<br/>1) за первый год кредитования 1,0% от суммы кредита на момент выдачи, увеличенной на 10%;<br/>2) за второй и последующие годы личное страхование — 0,7%, страхование имущества 0,3% от остатка ссудной задолженности, увеличенного на 10% (при наличии). <br/><br/>Условия по изменению процентной ставки по кредиту: <br/>1) При изменении условий продукта в части увеличения базовой процентной ставки и отсутствии заключенного кредитного договора по истечении 14 календарных дней с даты принятия Банком положительного решения по кредитной заявке на ранее действующих условиях продукта применяется процентная ставка по аналогичному виду продукта, действующему на дату заключения кредитного договора.<br/><br/>Указанные процентные ставки действуют при личном и имущественном страховании способом присоединения к Договору комплексного страхования.<br/>При заключении Индивидуального договора личного и имущественного страхования процентная ставка увеличивается на 0,5 процентных пункт. При отсутствии страхования любым способом процентная ставка увеличивается на 3 процентных пункта. Для участников «зарплатного проекта» Банка и при поступлении заявки от агентства недвижимости/ключевого партнера (застройщик) при сумме кредита до 3 000 000 рублей при первоначальном взносе до 20% процентная ставка снижается на 0,25 процентных пункта. ",
                        "minPercent": 7.95,
                        "maxPercent": 9.1,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1253,
                        "name": "Госипотека 2020",
                        "xmlId": "abc20465ea4-5476-4ca1-9772-3199d3035542",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "СТАВКИ указаны при сумме кредита от 5 млн рубл. При сумме кредита до 3 млн руб, ставки: ПВ от 10% - 8,45%, ПВ от 20% - 9,35%, При сумме кредита от 3 до  5 млн руб, ставки: ПВ от 10% - 8,2%, ПВ от 20% - 9,1%.<br/><br/>Стаж на последнем месте работы не менее 6 месяцев для наемных работников (не менее 3 месяцев при условии увольнения с предыдущего места работы и зачисления на новое место без прерывания трудового стажа и с увеличением уровня доходов), не менее 2 лет — для индивидуальных предпринимателей, лиц, занимающихся частной практикой, владельцев бизнеса. <br/><br/> • Справка по форме 2-НДФЛ, заверенная должным образом не требуется для: сотрудников Банка, участников «зарплатного проекта» Банка «Возрождение» (ПАО), ПАО «Промсвязьбанк», Сбербанка, ВТБ, Россельхозбанка, Газпромбанка,, зарплата которых полностью или в части, достаточной для получения кредитного продукта, проходит через СКС, а также для индивидуальных предпринимателей, владельцев бизнеса). <br/><br/>Список документов во вложении.  Максимум — 3 созаемщика (включая основного). <br/><br/>Платежи (ежегодные) за сбор, обработку и техническую передачу информации о физическом лице, связанную с распространением на него условий Договора ипотечного страхования, а также за распространение на него условий Договора ипотечного страхования из расчета:<br/>1) за первый год кредитования 1,0% от суммы кредита на момент выдачи, увеличенной на 10%;<br/>2) за второй и последующие годы личное страхование — 0,7%, страхование имущества 0,3% от остатка ссудной задолженности, увеличенного на 10% (при наличии). <br/><br/>Условия по изменению процентной ставки по кредиту: <br/>1) При изменении условий продукта в части увеличения базовой процентной ставки и отсутствии заключенного кредитного договора по истечении 14 календарных дней с даты принятия Банком положительного решения по кредитной заявке на ранее действующих условиях продукта применяется процентная ставка по аналогичному виду продукта, действующему на дату заключения кредитного договора.<br/><br/>Указанные процентные ставки действуют при личном и имущественном страховании способом присоединения к Договору комплексного страхования.<br/>При заключении Индивидуального договора личного и имущественного страхования процентная ставка увеличивается на 0,5 процентных пункт. При отсутствии страхования любым способом процентная ставка увеличивается на 3 процентных пункта. Для участников «зарплатного проекта» Банка и при поступлении заявки от агентства недвижимости/ключевого партнера (застройщик) при сумме кредита до 3 000 000 рублей при первоначальном взносе до 20% процентная ставка снижается на 0,25 процентных пункта. ",
                        "minPercent": 6,
                        "maxPercent": 6,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    }
                ],
                "minPercent": 4.5,
                "maxPeriod": 30,
                "minInitialPayment": 30,
                "formName": "Аккредитация Банк Возрождение в Солнечный город"
            },
            {
                "id": "11871",
                "logo": {
                    "id": 411036,
                    "src": "/upload/resize_cache/iblock/346/300_50_140cd750bba9870f18aada2478b24840a/1-10.jpg",
                    "contentType": "image/jpeg",
                    "width": 200,
                    "height": 50,
                    "description": ""
                },
                "name": "Россельхозбанк",
                "xmlId": "abc57",
                "bankPrograms": [
                    {
                        "id": 1160,
                        "name": "Военная Ипотека",
                        "xmlId": "abc883ddf75-f521-4a3f-8b45-5a5f880f85c3",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 2700000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 22,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 22,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Кредит предоставляется военнослужащим, проходящим военную службу по контракту и включенным в реестр участников НИС. Накопительно-ипотечная система жилищного обеспечения военнослужащих (НИС) – совокупность правовых, экономических и организационных отношений, направленных на реализацию прав военнослужащих на жилищное обеспечение. <br/><br/>Надбавка:+ 1,00% в случае отказа заемщика осуществить страхование жизни и здоровья либо несоблюдении им принятого на себя обязательства по обеспечению непрерывного страхования жизни и здоровья в течение всего срока действия кредитного договора .<br/><br/>Список документов: <br/>1) Заявление – анкета<br/>2) Паспорт гражданина РФ или документ, его заменяющий (в соответствии с требованиями Банка)<br/>3) Действующее Свидетельство о праве участника накопительно-ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа;<br/>4) Нотариально удостоверенное согласие супруга(и) заемщика на заключение сделки купли-продажи;<br/>5) Документы по кредитуемому объекту недвижимости",
                        "minPercent": 7.5,
                        "maxPercent": 7.5,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1164,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abc1efae371-dcb4-4a2a-9148-682503a00eda",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 100000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "С даты выдачи кредита предоставляется льготная процентная ставка на срок:<br/>1) 3 года – при рождении второго ребенка (для рассмотрения заявки представляются документы, подтверждающие рождение первого ребенка, и свидетельство о рождении второго ребенка);<br/>2) 5 лет – при рождении третьего ребенка (для рассмотрения заявки представляются документы, подтверждающие рождение первого и второго ребенка, и свидетельство о рождении третьего ребенка).<br/>3) При рождении в период с 01.01.2018 по 31.12.2022 (включительно) третьего ребенка период льготной процентной ставки продлевается на 5 лет со дня окончания периода предоставления льготной ставки в связи с рождением второго ребенка или возобновляется после предоставления свидетельства о рождении третьего ребенка. В целях подтверждения рождения третьего ребенка представляются документы, подтверждающие рождение первого и второго ребенка, и свидетельство о рождении третьего ребенка.<br/><br/>Льготная процентная ставка применяется в случае исполнения Заемщиком в полном объеме своих обязательств по уплате процентов за пользование кредитом (займом) и соблюдения Заемщиком обязательства по обеспечению непрерывного страхования жизни и здоровья и имущественного страхования:<br/>? заключения договоров страхования (страховой полис) жизни и здоровья, по которому выгодоприобретателем будет являться Кредитор, а также предоставления документов, подтверждающих оплату страховой премии/ страхового взноса;<br/>? заключения договоров страхования объекта недвижимости (страховых полисов), а также предоставления документов, подтверждающих оплату страховой премии/ страхового взноса (после оформления права собственности на объект недвижимости).",
                        "minPercent": 4.6,
                        "maxPercent": 9.3,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1185,
                        "name": "Господдержка 2020",
                        "xmlId": "abc8959f5ae-2af2-480b-ad30-936ea68b68e6",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 80,
                        "creditMin": 100000,
                        "creditMax": 20000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Плюс 1,00%  в случае отказа заемщика и/или солидарных заемщиков, доход которых был учтен при расчете суммы кредита, осуществить страхование жизни и здоровья либо несоблюдении ими принятого на себя обязательства по обеспечению непрерывного страхования жизни и здоровья в течение всего срока действия кредитного договора",
                        "minPercent": 5.9,
                        "maxPercent": 5.9,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1213,
                        "name": "Ипотека под залог имеющейся недвижимости",
                        "xmlId": "abc9ca95d6c-1a59-4235-8108-da582e216bcc",
                        "initialPaymentMin": 0,
                        "initialPaymentMax": 80,
                        "creditMin": 100000,
                        "creditMax": 20000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Участники зарплатного проекта/«надежные» клиенты1<br/><br/>9,30 % до 3 млн. ?<br/>9,10 % от 3 млн. ?<br/>Работники бюджетных организаций2<br/><br/>9,40 % до 3 млн. ?<br/>9,20 % от 3 млн. ?<br/>Иные физические лица<br/><br/>9,50 % до 3 млн. ?<br/>9,30 % от 3 млн. ?%",
                        "minPercent": 9.1,
                        "maxPercent": 9.1,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1224,
                        "name": "Два документа",
                        "xmlId": "abcc5e9fbef-bf7d-483e-a297-f881cb96de4b",
                        "initialPaymentMin": 40,
                        "initialPaymentMax": 60,
                        "creditMin": 100000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "При СК до 3 млн - ставка 11,9%<br/><br/>Надбавка к процентным ставкам:<br/>+ 1,00% в случае отказа заемщика и/или солидарных заемщиков, доход которых был учтен при расчете суммы кредита, осуществить страхование жизни и здоровья либо несоблюдении ими принятого на себя обязательства по обеспечению непрерывного страхования жизни и здоровья в течение всего срока действия кредитного договора.<br/><br/>Список документов:<br/>1) Заявление – анкета Заемщика<br/>2) паспорт гражданина РФ (удостоверение личности военнослужащего)<br/>3) Второй документ, удостоверяющий личность – любой из следующего списка:<br/>- водительское удостоверение;<br/>- удостоверение сотрудника федеральных органов власти (например, удостоверение депутата Государственной Думы и т.д.);<br/>- заграничный паспорт.<br/>4) Дополнительно при наличии свидетельства о браке: паспорт супруга и брачный договор (контракт) – при наличии.<br/>5) Для мужчин в возрасте до 27 лет (включ.) - военный билет или удостоверение граждан, подлежащих первичной постановке на воинский учет (приписное свидетельство).<br/>6) Документы по кредитуемому объекту недвижимости<br/>",
                        "minPercent": 8.8,
                        "maxPercent": 8.8,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 4.6,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация Россельхозбанк в Солнечный город"
            },
            {
                "id": "11860",
                "logo": {
                    "id": 411012,
                    "src": "/upload/resize_cache/iblock/7fc/300_50_140cd750bba9870f18aada2478b24840a/sankt-peterburg-bank-1024x409.png",
                    "contentType": "image/png",
                    "width": 125,
                    "height": 50,
                    "description": ""
                },
                "name": "Банк Санкт-Петербург",
                "xmlId": "abc1",
                "bankPrograms": [
                    {
                        "id": 1137,
                        "name": "Акция 9,7%",
                        "xmlId": "abc508cb4bb-9963-424e-9a91-26df085a7612",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 10000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Надбавки не применяются, при отказе от страхования /аккредитивной формы расчета применяется стандартная ставка.",
                        "minPercent": 9.7,
                        "maxPercent": 9.7,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1149,
                        "name": "Военная ипотека",
                        "xmlId": "abc8433f9b3-eabd-4282-8993-418212e4f60b",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 2200000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 12,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Список документов: <br/>1) Анкета <br/>2) Паспорт РФ <br/>3) Свидетельство о праве участника накопительно-ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа <br/>4) Свидетельство о браке (разводе) <br/>5) Удостоверение личности военнослужащего РФ<br/><br/>Максимальная сумма кредита рассчитывается исходя из размера процентной ставки, срока кредита и размера Ежемесячного аннуитетного платежа (1/12 Накопительного взноса, утвержденного федеральным законом о федеральном бюджете на текущий финансовый год.)<br/><br/> Скидки и надбавки к процентной ставке: 1) минус 0,25% Зарплатный клиент 2) минус 0,25% Клиенты, имеющие погашенную ипотеку в Банке 3) минус 0,25% Премиум/ VIP-клиент 4) плюс 1% Отказ от аккредитива/ эскроу 5) плюс 1% Отказ от каждого из видов страхования ",
                        "minPercent": 10,
                        "maxPercent": 10,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1169,
                        "name": "Акция 9,7% (2 док-та)",
                        "xmlId": "abc5b473206-d987-45a2-ac38-6f3032ab3afa",
                        "initialPaymentMin": 30,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 10000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Надбавки не применяются, при отказе от страхования /аккредитивной формы расчета применяется стандартная ставка.",
                        "minPercent": 9.7,
                        "maxPercent": 9.7,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1194,
                        "name": "Новостройка по паспорту",
                        "xmlId": "abc8f80feb0-67ec-4a53-8416-a396afcbf77f",
                        "initialPaymentMin": 30,
                        "initialPaymentMax": 70,
                        "creditMin": 500000,
                        "creditMax": 10000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Требования к заемщику:<br/>   • Гражданство РФ;<br/>   • Регистрация по месту жительства (постоянная регистрация) / по месту пребывания (временная регистрация) на территории РФ;<br/>   • Возраст от 18 лет до 60 лет (для женщин) / 65 лет (для мужчин) на момент полного погашения обязательств по кредиту;<br/>   • Для индивидуальных предпринимателей / владельцев бизнеса: Наличие действующего бизнеса (осуществление организацией, учредителем / акционером которой является Заемщик, безубыточной деятельности за последний завершенный финансовый год и истекший период текущего года) в административных границах субъекта РФ, на территории которого зарегистрирован любой дополнительный офис / филиал Банка<br/>   • Общий непрерывный трудовой стаж — не менее 1 (одного) года;<br/>   • Трудовой стаж на последнем месте работы:<br/>       * Для физических лиц, работающих по найму / военнослужащих: 4 (четыре) месяца;<br/>       * Для нотариусов / адвокатов: 12 (двенадцать) месяцев регистрации в качестве нотариуса / адвоката и осуществление прибыльной деятельности;<br/>       * Для индивидуальных предпринимателей: 12 (двенадцать) месяцев регистрации в качестве индивидуального предпринимателя и осуществления прибыльной деятельности.<br/><br/>Скидки и надбавки к процентной ставке: 1) минус 0,5% Зарплатный клиент 2) минус 0,5% Клиенты, имеющие погашенную ипотеку в Банке 3) минус 0,5% Премиум/ VIP-клиент 4) плюс 1% Отказ от аккредитива/ эскроу 5) плюс 1% Отказ от каждого из видов страхования ",
                        "minPercent": 9.5,
                        "maxPercent": 9.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1222,
                        "name": "Новостройка",
                        "xmlId": "abc266d514a-61bf-41b0-bc24-f3aa18352c67",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "первоначальный взнос: 1) от 10% при сумме кредитования до 10 млн.руб.; 2) от 30% при сумме кредитования до 30 млн.руб.<br/>Требования к заемщику:<br/>   • Гражданство РФ;<br/>   • Регистрация по месту жительства (постоянная регистрация) / по месту пребывания (временная регистрация) на территории РФ;<br/>   • Возраст от 18 лет до 60 лет (для женщин) / 65 лет (для мужчин) на момент полного погашения обязательств по кредиту;<br/>   • Для индивидуальных предпринимателей / владельцев бизнеса: Наличие действующего бизнеса (осуществление организацией, учредителем / акционером которой является Заемщик, безубыточной деятельности за последний завершенный финансовый год и истекший период текущего года) в административных границах субъекта РФ, на территории которого зарегистрирован любой дополнительный офис / филиал Банка<br/>   • Общий непрерывный трудовой стаж — не менее 1 (одного) года;<br/>   • Трудовой стаж на последнем месте работы:<br/>       * Для физических лиц, работающих по найму / военнослужащих: 4 (четыре) месяца;<br/>       * Для нотариусов / адвокатов: 12 (двенадцать) месяцев регистрации в качестве нотариуса / адвоката и осуществление прибыльной деятельности;<br/>       * Для индивидуальных предпринимателей: 12 (двенадцать) месяцев регистрации в качестве индивидуального предпринимателя и осуществления прибыльной деятельности.<br/><br/>Скидки и надбавки к процентной ставке: 1) минус 0,5% Зарплатный клиент 2) минус 0,5% Клиенты, имеющие погашенную ипотеку в Банке 3) минус 0,5% Премиум/ VIP-клиент 4) плюс 1% Отказ от аккредитива/ эскроу 5) плюс 1% Отказ от каждого из видов страхования ",
                        "minPercent": 9.5,
                        "maxPercent": 10.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1226,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abc90ec2f6b-7f2b-4d02-a58b-660901de331c",
                        "initialPaymentMin": 30,
                        "initialPaymentMax": 70,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Лица, имеющие право на получение кредита в рамках Госпрограммы: - Граждане РФ, у которых родился второй или третий ребенок в период с 01.01.2018 по 31.12.2022 г. (включительно), имеющий гражданство РФ. <br/>* на период до государственной регистрации ипотеки недвижимого имущества в силу договора и предоставления в Банк соответствующих документов применяется надбавка в размере ключевой ставки, действующей на момент заключения кредитного договора минус 2 п.п.",
                        "minPercent": 4.69,
                        "maxPercent": 6,
                        "minPeriod": 3,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1227,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abc5074e268-cd9e-4d03-b5cc-8961f0f06bd8",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Лица, имеющие право на получение кредита в рамках Госпрограммы: - Граждане РФ, у которых родился второй или третий ребенок в период с 01.01.2018 по 31.12.2022 г. (включительно), имеющий гражданство РФ. <br/>* на период до государственной регистрации ипотеки недвижимого имущества в силу договора и предоставления в Банк соответствующих документов применяется надбавка в размере ключевой ставки, действующей на момент заключения кредитного договора минус 2 п.п.",
                        "minPercent": 4.69,
                        "maxPercent": 6,
                        "minPeriod": 3,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1239,
                        "name": "Госпрограмма 2020",
                        "xmlId": "abca41ca226-c714-48a6-beb8-7021200b0c44",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Отказ от каждого из видов страхования - ставка выше на 1%",
                        "minPercent": 6.5,
                        "maxPercent": 6.5,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 4.69,
                "maxPeriod": 30,
                "minInitialPayment": 3,
                "formName": "Аккредитация Банк Санкт-Петербург в Солнечный город"
            },
            {
                "id": "11858",
                "logo": {
                    "id": 411309,
                    "src": "/upload/resize_cache/iblock/ff9/300_50_140cd750bba9870f18aada2478b24840a/domrf.jpg",
                    "contentType": "image/jpeg",
                    "width": 141,
                    "height": 50,
                    "description": ""
                },
                "name": "Банк ДОМ.РФ",
                "xmlId": "abc84",
                "bankPrograms": [
                    {
                        "id": 1138,
                        "name": "Строящаяся недвижимость (2 док-та)",
                        "xmlId": "abc04dce613-d7d2-42fb-8440-2748e3ff7185",
                        "initialPaymentMin": 35,
                        "initialPaymentMax": 85,
                        "creditMin": 500000,
                        "creditMax": 20000000,
                        "reviewPeriod": 2,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 24,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "Ставка указана при сумме кредита от 5 млн, при сумме кредита менее 5 млн - ставка 9,2%<br/><br/>Требуемые док-ты: <br/>1. Заявление-анкета <br/>2. Паспорт РФ <br/>3. Второй документ <br/>4. Для мужчин в возрасте до 27 лет - военный билет. <br/><br/>Для Заемщиков, планирующих использовать средства мат. капитала:<br/>1) Сертификат государственного образца на материнский (семейный) капитал <br/>2) Справка о состоянии финансовой части лицевого счета лица, имеющего право на дополнительные меры государственной поддержки. Возможно использоватьматеринский капитал. <br/><br/>Скидки к процентной ставке: <br/>1. Хотя бы один из заемщиков имеет 3 и более несовершеннолетних детей минус 0,25%<br/>2. Цель кредита—приобретение жилья в рамках программы «Жилье для российской семьи» минус 0,25%<br/>3. Предмет ипотеки расположен в Дальневосточном федеральном округе или Байкальском регионе Российской Федерации минус 0,25% (Республика Бурятия, Забайкальский край, Иркутская область.) <br/>4. Отсутствие личного страхования заемщика плюс 0,7% <br/>",
                        "minPercent": 8.7,
                        "maxPercent": 10.4,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1144,
                        "name": "Семейная ипотека с господдержкой",
                        "xmlId": "abc50133d7f-d2c0-40d3-9d18-2cd2fe515bb8",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 2,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Требуемые документы: <br/>1. Заявление-анкета<br/>2. Паспорт РФ <br/>3. Справка с места работы о размере дохода за последние 6 календарных месяцев по форме 2-НДФЛ3 либо по форме Банка. <br/>4. Копия ТК, заверенная работодателем <br/>5. Для мужчин в возрасте до 27 лет - военный билет. Выдача кредитов в рамках Госпрограммы  возможна не позднее 31.12.22 (включительно).<br/><br/>Лица, имеющие право на получение кредита в рамках Госпрограммы: - Граждане РФ, у которых родился второй или третий ребенок в период с 01.01.2018 по 31.12.2022 г. (включительно), имеющий гражданство РФ. ",
                        "minPercent": 4.7,
                        "maxPercent": 9.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1176,
                        "name": "Строящаяся недвижимость",
                        "xmlId": "abce576dc2c-bdae-4b02-b476-842c9743864e",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 85,
                        "creditMin": 500000,
                        "creditMax": 50000000,
                        "reviewPeriod": 2,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "СТАВКИ указаны при сумме кредита от 5 млн, при сумме кредита менее 5 млн ставки: ПВ от 15% - 10%, ПВ от 20% - 8,7%. <br/><br/>Скидки к процентной ставке: <br/>1. Хотя бы один из заемщиков имеет 3 и более несовершеннолетних детей минус 0,25% <br/>2. Цель кредита—приобретение жилья в рамках программы «Жилье для российской семьи» минус 0,25%<br/>3. Предмет ипотеки расположен в Дальневосточном федеральном округе или Байкальском регионе Российской Федерации минус 0,25% (Республика Бурятия, Забайкальский край, Иркутская область.) . <br/>4. Отсутствие личного страхования заемщика плюс 0,7% <br/>5. Клиент получает заработную плату на счет, открытый в АКБ «РОССИЙСКИЙ КАПИТАЛ» (АО) минус 0,2%<br/><br/>Требуемые документы: 1. Заявление-анкета 2. Паспорт РФ 3. Справка с места работы о размере дохода за последние 6 календарных месяцев по форме 2-НДФЛ3 либо по форме Банка. 4. Копия ТК, заверенная работодателем 5. Для мужчин в возрасте до 27 лет - военный билет.<br/><br/> Для Заемщиков, планирующих использовать средства мат. капитала:1) Сертификат государственного образца на материнский (семейный) капитал 2) Справка о состоянии финансовой части лицевого счета лица, имеющего право на дополнительные меры государственной поддержки.  При использовании мат капитала ПВ может быть от 10%. <br/><br/>Ставка ниже: 1) минус 0,5% (стоимость 2% от суммы кредита) 2)  минус 1% (стоимость 3,5% от суммы кредита) <br/><br/>Условия лучше для зарплатных клиентов АО Банк ДОМ.РФ или для клиентов, подтверждающих доход выпиской из Пенсионного фонда РФ 2:1) ставка ниже на 0,4 процентных пункта 2) первоначальный взнос от 10% от стоимости недвижимости 3) не нужны трудовая книжка и справка о доходах",
                        "minPercent": 8.2,
                        "maxPercent": 9.9,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1180,
                        "name": "Военная ипотека",
                        "xmlId": "abce84ce427-42e4-47a2-8226-8fca9853b558",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 2948000,
                        "reviewPeriod": 2,
                        "maleAgeMin": 25,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 25,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 36,
                        "requirements": "Кредит предоставляется военнослужащим участникам накопительно-ипотечной системы, имеющим право на получение целевого жилищного займа на основании Федерального закона «О накопительно-ипотечной системе жилищного обеспечения военнослужащих» №117-ФЗ от 20.08.2004г. Получение кредита без подтверждения платежеспособности.<br/> <br/>Для рассмотрения кредитной заявки необходимы:<br/>1) Анкета для заполнения;<br/>2) Паспорт заемщика (поручителя) (предъявляется);<br/>3) Свидетельство о праве участника накопительно-ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа;",
                        "minPercent": 8.5,
                        "maxPercent": 8.5,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1225,
                        "name": "Семейная ипотека с господдержкой",
                        "xmlId": "abcb0c8e435-5978-4cf1-acfc-f8aef9963526",
                        "initialPaymentMin": 50,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 2,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Требуемые документы: <br/>1. Заявление-анкета<br/>2. Паспорт РФ <br/>3. Справка с места работы о размере дохода за последние 6 календарных месяцев по форме 2-НДФЛ3 либо по форме Банка. <br/>4. Копия ТК, заверенная работодателем <br/>5. Для мужчин в возрасте до 27 лет - военный билет. Выдача кредитов в рамках Госпрограммы  возможна не позднее 31.12.22 (включительно).<br/><br/>Лица, имеющие право на получение кредита в рамках Госпрограммы: - Граждане РФ, у которых родился второй или третий ребенок в период с 01.01.2018 по 31.12.2022 г. (включительно), имеющий гражданство РФ. ",
                        "minPercent": 4.7,
                        "maxPercent": 6,
                        "minPeriod": 3,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1243,
                        "name": "Ипотека господдержка 2020",
                        "xmlId": "abce9d387dd-16fd-4723-ad30-b433ac5a9808",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 1000000,
                        "creditMax": 8000000,
                        "reviewPeriod": 2,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": " Если без при подтверждении дохода выпиской из Пенсионного фонда - ставка выше на 0,4%",
                        "minPercent": 6.1,
                        "maxPercent": 6.1,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 4.7,
                "maxPeriod": 30,
                "minInitialPayment": 3,
                "formName": "Аккредитация Банк ДОМ.РФ в Солнечный город"
            },
            {
                "id": "11875",
                "logo": {
                    "id": 411040,
                    "src": "/upload/resize_cache/iblock/290/300_50_140cd750bba9870f18aada2478b24840a/Logotip-Sovkombank-1280x960.jpg",
                    "contentType": "image/jpeg",
                    "width": 246,
                    "height": 50,
                    "description": ""
                },
                "name": "Совкомбанк",
                "xmlId": "abc88",
                "bankPrograms": [
                    {
                        "id": 1156,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abc335ac268-ecf8-40f5-a062-5353c9160e1a",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 1,
                        "maleAgeMin": 20,
                        "maleAgeMax": 85,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 85,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Процентные ставки и условия ипотеки с господдержкой<br/><br/>Ставка по кредиту по программе «Ипотека с господдержкой для семей с детьми»: <br/>1) на льготный период – 6%;<br/>2) после окончания льготного периода – ключевая ставка ЦБ РФ на дату подписания кредитного договора + 2 п.п.;<br/>полное страхование.<br/><br/>Длительность льготного периода:<br/>3 года - в случае рождения второго ребенка с период с 01.01.2018 по 31.12.2022;<br/>5 лет - в случае рождения третьего ребенка с период с 01.01.2018 по 31.12.2022;<br/>8 лет - в случае рождения второго и третьего ребенка с период с 01.01.2018 по 31.12.2022;",
                        "minPercent": 4.9,
                        "maxPercent": 9.25,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1215,
                        "name": "Новостройка",
                        "xmlId": "abca298fc2c-db78-4c15-b277-dff6249fffd1",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 30000000,
                        "reviewPeriod": 1,
                        "maleAgeMin": 20,
                        "maleAgeMax": 85,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 85,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Требования к заемщику: <br/>1) Гражданство РФ <br/>2) Постоянная регистрация по месту жительства либо временная регистрация сроком от 4-х месяцев <br/>3) Общий трудовой стаж не менее 1 года и непрерывный трудовой стаж работы на последнем месте - не менее 3 месяцев (к лицам, участвующим в сделке без подтверждения доходов, данное требование не применяется). <br/>4) Если Заемщик состоит в зарегистрированном браке, то  супруги выступают в качестве солидарных Заемщиков. В случае наличия между супругами брачного договора/ контракта, устанавливающего режим раздельной собственности на имущество, возможно проведение сделки при участии только одного супруга, при условии наличия у него постоянного источника дохода; <br/>5) Лицо мужского пола в возрасте до 27 лет при отсутствии документов, подтверждающих отсрочку от призыва  на военную службу до достижения 27 лет или зачисление в запас, может являться Заемщиком при условии привлечения в качестве созаемщика родственника, не подлежащего призыву на  военную службу;<br/>6) Для собственников бизнеса и индивидуальных предпринимателей – срок ведения собственного бизнеса/ предпринимательской деятельности - не менее 12 месяцев На территории Российской Федерации. <br/><br/>Список документов: <br/>1. Анкета-заявление <br/>2. Копия всех страниц паспорта <br/>3. Копия трудовой книжки, заверенная работодателем <br/>4. Копия справки о дохода  <br/>5. СНИЛС. <br/>6. Военный билет (для мужчин в возрасте до 27 лет.<br/><br/> Надбавки к процентным ставкам: <br/> 1) для ИП плюс 1% 2) минус 0,5%  для ЗП клиентов<br/><br/>Воспользуйтесь возможностью пересчитать Ваш кредит по ставке 5,9%: подключите программу «Гарантия Отличной Ставки».<br/>Программа «Гарантия Отличной Ставки» — это добровольная платная услуга Банка для держателей карт рассрочки «Халва» по снижению процентной ставки за период действия данной услуги по Кредитному договору, заключенному между Банком и заемщиком.<br/>Стоимость услуги — 2,9% от первоначальной суммы кредита, которая удерживается единовременно в дату подключения услуги. Срок действия услуги — 3 года. Условия подключения, которые должны соблюдаться в период действия услуги: наличие Личного страхования (Финансовой защиты), отсутствие просрочек, а также совершение по карте рассрочки «Халва» не менее 5 операций на общую сумму от 10 000 рублей собственными/заемными средствами в каждом полном отчетном периоде",
                        "minPercent": 8.15,
                        "maxPercent": 8.65,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1228,
                        "name": "Господдержка 2020",
                        "xmlId": "abcdf583590-6695-4214-9138-91572f197485",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 8000000,
                        "reviewPeriod": 1,
                        "maleAgeMin": 20,
                        "maleAgeMax": 85,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 85,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Требования к заемщику: <br/>1) Гражданство РФ <br/>2) Постоянная регистрация по месту жительства либо временная регистрация сроком от 4-х месяцев <br/>3) Общий трудовой стаж не менее 1 года и непрерывный трудовой стаж работы на последнем месте - не менее 3 месяцев (к лицам, участвующим в сделке без подтверждения доходов, данное требование не применяется). <br/>4) Если Заемщик состоит в зарегистрированном браке, то  супруги выступают в качестве солидарных Заемщиков. В случае наличия между супругами брачного договора/ контракта, устанавливающего режим раздельной собственности на имущество, возможно проведение сделки при участии только одного супруга, при условии наличия у него постоянного источника дохода; <br/>5) Лицо мужского пола в возрасте до 27 лет при отсутствии документов, подтверждающих отсрочку от призыва  на военную службу до достижения 27 лет или зачисление в запас, может являться Заемщиком при условии привлечения в качестве созаемщика родственника, не подлежащего призыву на  военную службу;<br/>6) Для собственников бизнеса и индивидуальных предпринимателей – срок ведения собственного бизнеса/ предпринимательской деятельности - не менее 12 месяцев На территории Российской Федерации. <br/><br/>Список документов: <br/>1. Анкета-заявление <br/>2. Копия всех страниц паспорта <br/>3. Копия трудовой книжки, заверенная работодателем <br/>4. Копия справки о дохода  <br/>5. СНИЛС. <br/>6. Военный билет (для мужчин в возрасте до 27 лет.<br/><br/> Надбавки к процентным ставкам: <br/>1) для ИП плюс 1,5% <br/>2) для собственникобизнеса плюс 3% <br/>3) Без страхования Заемщика (ов) от смерти, постоянной полной нетрудоспособности, дожития до события недобровольной потери работы, а также первичного диагностирования смертельно опасных заболеваний при выдаче кредита плюс2,75% <br/>4) Без страхования от рисков потери недвижимого имущества в результате полной или частичной утраты права собственности Заемщика (ов) на недвижимое имущество плюс 2,75%<br/><br/>",
                        "minPercent": 6.49,
                        "maxPercent": 6.49,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 4.9,
                "maxPeriod": 30,
                "minInitialPayment": 30,
                "formName": "Аккредитация Совкомбанк в Солнечный город"
            },
            {
                "id": "11856",
                "logo": {
                    "id": 411004,
                    "src": "/upload/resize_cache/iblock/119/300_50_140cd750bba9870f18aada2478b24840a/DYPBCGmXUAA_SbA.png",
                    "contentType": "image/png",
                    "width": 89,
                    "height": 50,
                    "description": ""
                },
                "name": "Банк Зенит",
                "xmlId": "abc87",
                "bankPrograms": [
                    {
                        "id": 1135,
                        "name": "\"Семейный\" на новостройку для военных",
                        "xmlId": "abcc2853b8b-e54e-49c5-b5cf-2530b4acbbcf",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 8060000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 6,
                        "businessPeriod": 36,
                        "requirements": "Кредит на покупку квартиры в новостройке для  супругов-военнослужащих. <br/><br/>Сумма кредита может быть увеличена до 6 млн рублей с опцией «Ипотека+» (разница между суммой ежемесячного платежа и размером платежа за счёт средств ЦЖЗ погашается за счёт собственных средств военнослужащего (ежемесячно))<br/><br/> Документы: <br/>1) Свидетельство участника НИС <br/>2) Паспорт РФ",
                        "minPercent": 8.5,
                        "maxPercent": 8.5,
                        "minPeriod": 23,
                        "maxPeriod": 23
                    },
                    {
                        "id": 1199,
                        "name": "Военная ипотека",
                        "xmlId": "abc3e91e828-2f15-43a5-8072-ba79a65c701c",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 4030000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 6,
                        "businessPeriod": 36,
                        "requirements": "Требуемые Документы: <br/>1) Заявление – анкета<br/>2 ) Паспорт гражданина Российской Федерации<br/>3) Свидетельство о праве участника накопительно -ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа. <br/><br/>• Сумма может быть увеличена до 3,0 млн рублей с опцией «Ипотека+» (разница между суммой ежемесячного платежа и размером платежа за счёт средств ЦЖЗ погашается за счёт собственных средств военнослужащего (ежемесячно))",
                        "minPercent": 8.5,
                        "maxPercent": 8.5,
                        "minPeriod": 23,
                        "maxPeriod": 23
                    },
                    {
                        "id": 1211,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abc0f9ac759-352a-4f1c-bd3a-d3e697e80fb5",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 600000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 22,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 22,
                        "femaleAgeMax": 65,
                        "totalPeriod": 24,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "Программа для Граждан РФ, у которых в период с 1 января 2018 года по 31 декабря 2022 года родится второй или третий ребёнок.<br/><br/> Льготный срок: <br/>1) При рождении второго ребёнка ставка в размере 6% годовых действует три года<br/>2)  при рождении третьего ребёнка – пять лет<br/>3) если в период действия программы в семье с двумя детьми родится третий ребёнок, действие льготной ставки будет продлено на пять лет. <br/><br/>По окончании льготного периода стоимость кредита будет рассчитываться по формуле: ключевая ставка ЦБ РФ на дату предоставления кредита + 2 процентных пункта. <br/><br/>Для получения ипотечного кредита необходимы следующие документы:<br/>1) паспорт РФ;<br/> 2) справка о доходах по форме 2-НДФЛ или по форме Банка; <br/>3) копия трудовой книжки, заверенная работодателем; <br/>4) копия свидетельства о заключении брака/ копия брачного договора/ копия свидетельства о расторжении брака (при наличии); <br/>5) копия свидетельства о рождении/ усыновлении ребёнка (детей); <br/>6) сертификат на материнский капитал (при использовании средств материнского капитала для внесения первоначального взноса); <br/>7) справка из Пенсионного фонда РФ об остатке средств материнского капитала (при использовании средств материнского капитала для внесения первоначального взноса);",
                        "minPercent": 6,
                        "maxPercent": 9.25,
                        "minPeriod": 3,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1248,
                        "name": "Госсубсидирование ипотеки для семей с детьми",
                        "xmlId": "abcbd920efc-0ca4-43a3-ba93-fc70aedf19f1",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 15000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 22,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 22,
                        "femaleAgeMax": 65,
                        "totalPeriod": 24,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "• За счёт средств материнского капитала Вы можете снизить первоначальный взнос на сумму, не превышающую 5% от стоимости приобретаемой квартиры. <br/><br/>Для оформления кредита необходимы следующие документы:<br/>1) Копия трудовой книжки, заверенная работодателем<br/>2) Паспорт РФ<br/>3) Копия свидетельства о заключении брака<br/>4) Копия военного билета<br/>5) Копии документов об образовании<br/>6) Информация о компании-работодателе (по форме Банка)<br/>7) Справка о заработной плате и иных доходах 2-НДФЛ или по форме Банка 8) заявление-анкета<br/>Дополнительно Вы можете предоставить:СНИЛС, ИНН, загранпаспорт, водительское удостоверение.<br/><br/> Надбавки к процентной ставке: <br/>1) +1,5% при отсутствии личного и/или титульного страхования; <br/>2) +1% в случае ненаправления средств материнского капитала на частичное досрочное погашение ипотечного кредита в течение трёх месяцев с даты его оформления.<br/><br/>Если клиент ет зарплату на карту Банка Зенит / работает в группе компаний Татнефть ставка 8,7%",
                        "minPercent": 4.9,
                        "maxPercent": 4.9,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    }
                ],
                "buildings": [
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    }
                ],
                "minPercent": 4.9,
                "maxPeriod": 30,
                "minInitialPayment": 3,
                "formName": "Аккредитация Банк Зенит в Солнечный город"
            },
            {
                "id": "11870",
                "logo": {
                    "id": 410966,
                    "src": "/upload/resize_cache/iblock/f77/300_50_140cd750bba9870f18aada2478b24840a/raiffaizen.jpg",
                    "contentType": "image/jpeg",
                    "width": 176,
                    "height": 50,
                    "description": ""
                },
                "name": "Райффайзен банк",
                "xmlId": "abc78",
                "bankPrograms": [
                    {
                        "id": 1129,
                        "name": "Квартира в новостройке",
                        "xmlId": "abcd43ad072-e094-4b06-b172-14980c4ff845",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 90,
                        "creditMin": 800000,
                        "creditMax": 26000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 36,
                        "requirements": "Ставка указана при сумме кредита от 3 до 7  млн. Если сумма кредита до 3 млн, то ставка 9,85%.Если сумма кредита от 7млн ставка 9,29% Все эти ставки действуют только для зарплатных клиентов, а также премиальных клиентов, которые обслуживаются в банке не менее 6 месяцев с момента открытия счетов в банке и/или имеют обороты и/или остатки по счетам, достаточные для бесплатного обслуживания пакета услуг «Премиальный».ПВ 10% только для зарплатных клиентов, а также премиальных клиентов, которые обслуживаются в банке не менее 6 месяцев с момента открытия счетов в банке и/или имеют обороты и/или остатки по счетам, достаточные для бесплатного обслуживания пакета услуг «Премиальный»<br/><br/> Для остальных категорий клиентов —ставка 10,1%.<br/><br/>Требования к стажу:<br/>1) Физические лица, работающие по найму:<br/>- Не менее 6 месяцев при общем трудовом стаже не менее 1 года.<br/>- Не менее 3 месяцев при общем трудовом стаже не менее 2 лет.<br/>- Не менее 1 года, если данное место работы первое для заемщика.<br/>2)  Нотариусы, занимающиеся частной практикой/адвокаты с собственным адвокатским кабинетом: профессиональная деятельность должна вестись не менее 1 финансового года.<br/>3) Владельцы/совладельцы бизнеса/индивидуальные предприниматели: деятельность компании должна вестись не менее 3 финансовых лет. <br/> <br/>Список документов: <br/>1) Паспорт РФ <br/>2) СНИЛС<br/>3) Свидетельство о заключении брака/Свидетельство о расторжении брака <br/>4) копия ТК <br/>5) 2 НДФл или справка по форме банка. <br/>Полный список док-ов во вложении. <br/><br/>Возможно использовать мат. капитал<br/><br/>",
                        "minPercent": 8.39,
                        "maxPercent": 8.89,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1130,
                        "name": "Ипотека с  господдержкой",
                        "xmlId": "abc61eee249-ad12-4a10-a53f-179eaaaf7365",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 36,
                        "requirements": "Главное услловие - Наличие у Заемщика второго либо третьего ребенка, рожденного в период с 1 января 2018 года по 31 декабря 2022 года, имеющего гражданство РФ. <br/><br/>Ставка в размере 6% действует: <br/>1) 36 месяцев с даты выдачи кредита в связи с рождением у Заемщика второго ребенка в период с 01 января 2018 года по 31 декабря 2022 года <br/>2) 60 месяцев с даты выдачи кредита в связи с рождением у Заемщика третьего ребенка в период с 01 января 2018 года по 31 декабря 2022 года<br/>Период действия льготной ставки может быть продлен/возобновлен на 60 месяцев при предоставлении документов, подтверждающих рождение у Заемщика третьего ребенка в период с даты выдачи кредита по 31 декабря 2022 года.<br/>После окончания срока действия льготной ставки уровень процентной ставки изменяется до уровня не превышающем размер ключевой ставки ЦБ РФ, установленной на дату выдачи кредита, увеличенной на 2 процентных пункта.<br/><br/>Требования к стажу:<br/>1) Физические лица, работающие по найму:<br/>- Не менее 6 месяцев при общем трудовом стаже не менее 1 года.<br/>- Не менее 3 месяцев при общем трудовом стаже не менее 2 лет.<br/>- Не менее 1 года, если данное место работы первое для заемщика.<br/>2)  Нотариусы, занимающиеся частной практикой/адвокаты с собственным адвокатским кабинетом: профессиональная деятельность должна вестись не менее 1 финансового года.<br/>3) Владельцы/совладельцы бизнеса/индивидуальные предприниматели: деятельность компании должна вестись не менее 3 финансовых лет. <br/> <br/>Список документов: <br/>1) Паспорт РФ <br/>2) СНИЛС<br/>3) Свидетельство о заключении брака/Свидетельство о расторжении брака <br/>4) копия ТК <br/>5) 2 НДФл или справка по форме банка. <br/>Полный список док-ов во вложении. <br/>",
                        "minPercent": 4.99,
                        "maxPercent": 9.25,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1247,
                        "name": "Госпрограмма 2020",
                        "xmlId": "abce9aabd57-31d1-4fed-a934-fc207663dad0",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 800000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 36,
                        "requirements": "Плюс 0.5 п.п. к ставке без личного и/или титульного страхования; + 3.2 п.п. если возраст заемщика на момент подачи документов превышает 45 лет и 1 мес.<br/><br/>",
                        "minPercent": 6.5,
                        "maxPercent": 6.5,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    }
                ],
                "minPercent": 4.99,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация Райффайзен банк в Солнечный город"
            },
            {
                "id": "11853",
                "logo": {
                    "id": 410996,
                    "src": "/upload/resize_cache/iblock/bae/300_50_140cd750bba9870f18aada2478b24840a/absolutbankpng_logotip.png",
                    "contentType": "image/png",
                    "width": 166,
                    "height": 50,
                    "description": ""
                },
                "name": "Абсолют банк",
                "xmlId": "abc6",
                "bankPrograms": [
                    {
                        "id": 1139,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abcba43c378-3643-44d4-a2d2-2a18dc500f9d",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 79.99,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Программа для семей с детьми, где второй и/или последующие дети рождены в период с 1 января 2018 по 31 декабря 2022 года., а также для семей имеющего ребенка, рожденного не позднее 31 декабря 2022 г. и которому установлена категория ребенок-инвалид.<br/>Программа позволяет оформить кредит на покупку объекта недвижимости на льготных условиях. Указанный размер процентной ставки устанавливается для клиентов соответствующих Правилам программы и заключивших кредитный договор в<br/>период с 01.01.2018г. до 31.12.2022г. и до 01.03.2023г. в случае рождения второго ребенка и (или) последующих детей с 01.07.2022г. по 31.12.2022г,<br/>Также льготная ставка устанавливается при заключении кредитного договора до 31.12.2022г. для клиентов с наличием ребенка-инвалида рожденного до 31.12.2022г, и до 31.12.2027г. в случае установления категории ребенок-инвалид после 31.12.2022г..<br/><br/>В случае нарушения Заемщиком обязательств по уплате процентов за пользованием кредитом в течение срока действия кредитного договора, процентная ставка повышается до размера ключевой ставки Банка России, действующей на 1-й день календарного месяца, увеличенной на 4%, начиная с процентного периода, следующего за процентным периодом, в котором допущено соответствующее нарушение;<br/> <br/>В случае незаключения Заемщиком договоров личного страхования (страхования жизни, страхования от несчастного случая и болезни) и<br/>страхования жилого помещения после оформления права собственности на жилое помещение, процентная ставка повышается на 4% начиная с процентного периода, следующего за процентным периодом, в котором допущено соответствующее нарушение.",
                        "minPercent": 4.99,
                        "maxPercent": 9.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1163,
                        "name": "Военная ипотека",
                        "xmlId": "abc3c68efed-7fb1-43da-9109-66d5e30e34b2",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 2656000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 36,
                        "requirements": "Список док-ов:<br/>• Свидетельство о праве военнослужащего - участника НИС на получение ЦЖЗ;<br/>• Документы о семейном положении – свидетельство о заключении/расторжении брака (при наличии);<br/>• Брачный контракт или иное соглашение между супругами, изменяющее законный режим собственности супругов (при наличии).<br/><br/>Максимальная сумма кредита: 1. 2 460 000 рублей РФ в случае погашения кредита за счет ежемесячных платежей НИС;<br/>2. 3 075 000 рублей РФ в случае погашения кредита за счет ежемесячных платежей НИС и<br/>собственных средств Заемщика (в размере не более 25% от ежемесячного платежа НИС). Программа «Военная ипотека-Первичный рынок» предусматривает погашение ежемесячного аннуитетного платежа за счет ежемесячного платежа НИС в размере 1/12 накопительного взноса, утвержденного федеральным законом о федеральном<br/>бюджете на текущий финансовый год (в котором Заемщик оформляет Кредитный договор), а также (по желанию Заемщика) за счет<br/>ежемесячного платежа Заемщика, сформированного за счет собственных средств, в раз",
                        "minPercent": 9.95,
                        "maxPercent": 9.95,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1221,
                        "name": "Новостройки",
                        "xmlId": "abc15ef1de4-8b85-4514-9f71-f2705e0fa5e5",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 79.99,
                        "creditMin": 300000,
                        "creditMax": 20000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "При подключении опции Абсолютная ставка - снижение ставки на 0,5% (оплата 2% от Суммы кредита в день подписания договора).<br/><br/>Скидки и надбавки к процентной ставке (суммируются между собой):<br/>1) -0,25% годовых, в случае присоединения Заемщика к договору коллективного ипотечного страхования (при приобретения апартаментов - только<br/>при страховании жизни Заемщика (Созаемщиков) и потери трудоспособности Заемщиком (Созаемщиков));<br/>-2) 0,25% годовых, при поступлении заявки по электронным каналам (в т.ч. при оформлении заявки на сайте банка);<br/>3) +1% годовых, в случае подтверждения доходов Заемщика (Созаемщиков) анкетными данными;<br/>4) +1% годовых в случае, если по истечении 6 (шести) месяцев, с даты передачи квартиры/апартаментов Заемщику Банку не будет предоставлена<br/>закладная, выданная органом, осуществляющим государственную регистрацию прав на недвижимое имущество и сделок с ним, содержащая<br/>указание на обременение квартиры/апартаментов залогом (ипотекой) в пользу Банка. Указанная надбавка неприменима в случае приобретения<br/>квартиры/апартаментов на первичном рынке недвижимости по договору купли-продажи;<br/>5) +1% годовых для заемщиков, осуществляющих предпринимательскую деятельность;<br/>6) +3% годовых в случае приобретения квартиры/апартаментов на первичном рынке недвижимости по предварительному договору купли-продажи<br/>(надбавка устанавливается до получения Банком зарегистрированной закладной, предоставляемой Заемщиком Банку в соответствии с условиями<br/>Кредитного договора);<br/>7) +4% годовых в случае отсутствия личного и титульного страхования;<br/><br/>• Первоначальный взнос формируется за счет средств (части средств) материнского (семейного) капитала и собственных средств Заемщика (Созаемщиков). При этом, первоначальный взнос за счет собственных средств не менее 10% от стоимости приобретаемой недвижимости. <br/><br/>• ПВ для собствееников бизнеса минимум 30%. <br/><br/>• При сумме кредита от 10 000 000 рублей РФ и более, минимальный размер первоначального взноса составляет 30% (данное требование также применимо в случае использования средств материнского (семейного) капитала). <br/><br/>• В случае подтверждения дохода Заемщика (Созаемщиков) анкетными данными минимальный размер первоначального взноса составляет 60%., но не более 6 млн руб.<br/><br/>",
                        "minPercent": 10.5,
                        "maxPercent": 10.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    }
                ],
                "minPercent": 4.99,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация Абсолют банк в Солнечный город"
            },
            {
                "id": "11872",
                "logo": {
                    "id": 406452,
                    "src": "/upload/resize_cache/iblock/8dc/300_50_140cd750bba9870f18aada2478b24840a/logotip_sberbanka_31_11071021.png",
                    "contentType": "image/png",
                    "width": 175,
                    "height": 50,
                    "description": ""
                },
                "name": "Сбербанк",
                "xmlId": "abc3",
                "bankPrograms": [
                    {
                        "id": 1124,
                        "name": "Новостройка",
                        "xmlId": "abcd5e78488-7973-477d-a005-0055537d5c83",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 85,
                        "creditMin": 300000,
                        "creditMax": 70000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Ставки действуют для клиентов, получающих зарплату на счет карты/вклада в Сбербанке с учетом «Сервиса электронной регистрации». ПВ для ЗП клиентов от 10%<br/><br/>Надбавки: <br/>1) +1% — при отказе от страхования жизни и здоровья заемщика в соответствии с требованиями Банка.<br/>2) +0,3% — для клиентов, не получающих зарплату на счет карты или вклада в Сбербанке/для клиентов, не предоставивших подтверждение дохода и занятости в случае, когда приобретаемый объект недвижимости построен с участием кредитных средств Банка при условии первоначального взноса от 50%.<br/><br/><br/>Основные документы: <br/>1) Заявление-анкета заемщика/созаемщика;<br/>2) паспорт заемщика/созаемщика с отметкой о регистрации;<br/>3) документ, подтверждающий регистрацию по месту пребывания (при наличии временной регистрации);<br/>4) документы, подтверждающие финансовое состояние и трудовую занятость заемщика/созаемщика (во вложении); Достаточно паспорта РФ для подачи заявки на кредит клиентам, получающим заработную плату на счет, открытый в Сбербанке.<br/>5) Если в качестве обеспечения по кредиту оформляется залог иного объекта недвижимости, то потреюуются документы по предоставляемому залогу.<br/><br/>9,0% годовых – процентная ставка для лиц, являющихся участниками государственных федеральных и региональных программ, направленных на развитие жилищной сферы, реализуемых в рамках соглашений о сотрудничестве ПАО Сбербанк с субъектами РФ и муниципальными образованиями.",
                        "minPercent": 8.7,
                        "maxPercent": 9.1,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1126,
                        "name": "Военная ипотека",
                        "xmlId": "abc51ad8db4-799d-45e7-989f-07f75b0c5afb",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 2629000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Кредит предоставляется военнослужащим участникам накопительно-ипотечной системы, имеющим право на получение целевого жилищного займа на основании Федерального закона «О накопительно-ипотечной системе жилищного обеспечения военнослужащих» №117-ФЗ от 20.08.2004г. <br/><br/>Получение кредита без подтверждения платежеспособности.<br/><br/> Для рассмотрения кредитной заявки необходимы:<br/>1) Анкета для заполнения;<br/>2) Паспорт заемщика (поручителя) (предъявляется);<br/>3) Свидетельство о праве участника накопительно-ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа;",
                        "minPercent": 8.8,
                        "maxPercent": 8.8,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1165,
                        "name": "Новостройка (2 док-та)",
                        "xmlId": "abc476b01ee-4e0b-4891-b2b2-69afed6c5cf1",
                        "initialPaymentMin": 50,
                        "initialPaymentMax": 85,
                        "creditMin": 300000,
                        "creditMax": 70000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Ставки действуют для клиентов, получающих зарплату на счет карты/вклада в Сбербанке, либо в случае, когда приобретаемый объект недвижимости построен с участием кредитных средств Банка, с учетом «Сервиса электронной регистрации».<br/><br/>Надбавки: 1) +1% — при отказе от страхования жизни и здоровья заемщика в соответствии с требованиями Банка.<br/>2) +0,3% — для клиентов, не получающих зарплату на счет карты/вклада в Сбербанке. <br/>Достаточно паспорта РФ для подачи заявки на кредит клиентам, получающим заработную плату на счет, открытый в Сбербанке. <br/> <br/>Основные документы: <br/>1) Заявление-анкета заемщика/созаемщика;<br/>2) паспорт заемщика/созаемщика с отметкой о регистрации;<br/>3) документ, подтверждающий регистрацию по месту пребывания (при наличии временной регистрации);<br/>4) документы, подтверждающие финансовое состояние и трудовую занятость заемщика/созаемщика (во вложении); Достаточно паспорта РФ для подачи заявки на кредит клиентам, получающим заработную плату на счет, открытый в Сбербанке.<br/>5) Если в качестве обеспечения по кредиту оформляется залог иного объекта недвижимости, то потреюуются документы по предоставляемому залогу<br/><br/>Приобретая готовое или строящееся жилье в кредит с помощью Сбербанка, вы можете использовать средства материнского капитала для первоначального взноса или его части.",
                        "minPercent": 9,
                        "maxPercent": 9,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1189,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abcdcb5c14c-ae35-4fa8-8f82-9c61bd6d34ce",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 85,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Выдача кредитов в рамках Госпрограммы  возможна не позднее 31.12.22 (включительно).<br/><br/>Лица, имеющие право на получение кредита в рамках Госпрограммы: - Граждане РФ, у которых родился второй или третий ребенок в период с 01.01.2018 по 31.12.2022 г. (включительно), имеющий гражданство РФ. <br/><br/>Надбавки: <br/>+1 п.п. - в случае отказа заемщика от страхования жизни и здоровья, в соответствии с требованиями Банка",
                        "minPercent": 5,
                        "maxPercent": 9.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1246,
                        "name": "Госпрограмма 2020",
                        "xmlId": "abca51d6b19-4bef-48f3-90b5-e634d4a4bd9f",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Надбавки:<br/>+1 п.п. - в случае отказа заемщика от страхования жизни и здоровья, в соответствии с требованиями Банка ",
                        "minPercent": 6.4,
                        "maxPercent": 6.4,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 5,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация Сбербанк в Солнечный город"
            },
            {
                "id": "11861",
                "logo": {
                    "id": 411014,
                    "src": "/upload/resize_cache/iblock/29a/300_50_140cd750bba9870f18aada2478b24840a/vtb.png",
                    "contentType": "image/png",
                    "width": 131,
                    "height": 50,
                    "description": ""
                },
                "name": "ВТБ",
                "xmlId": "abc8",
                "bankPrograms": [
                    {
                        "id": 1140,
                        "name": "Военная Ипотека",
                        "xmlId": "abccfd68120-de24-461e-a9d5-2b31c3330d07",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 640000,
                        "creditMax": 2990000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Программа рассчитана на военнослужащих — участников накопительно-ипотечной системы (НИС). Программа позволяет получить жилье без привлечения собственных средств. Недвижимость и регион вы выбираете сами, а государство осуществляет погашение вашего ипотечного кредита.<br/><br/>После выхода из НИС ставка 10%.<br/><br/>Документы: <br/>1) Анкета-заявление <br/>2) Паспорт РФ <br/>3) ИНН или СНИЛС <br/>4) Свидетельство о праве участника НИС на получение целевого жилищного займа<br/> <br/>• Срок кредита до 20 лет, но не позднее достижения заемщиком возраста 45 лет на дату погашения кредита;",
                        "minPercent": 8.5,
                        "maxPercent": 8.5,
                        "minPeriod": 14,
                        "maxPeriod": 14
                    },
                    {
                        "id": 1175,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abcd4829ca5-f040-404d-bedf-83c06b28d87e",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 1000000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Ставка по кредиту по программе «Ипотека с господдержкой для семей с детьми»",
                        "minPercent": 5,
                        "maxPercent": 9.25,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1195,
                        "name": "Строящееся жилье (2 документа)",
                        "xmlId": "abc3f7ad548-8057-41af-afb1-a50b246aed25",
                        "initialPaymentMin": 30,
                        "initialPaymentMax": 95,
                        "creditMin": 1000000,
                        "creditMax": 30000000,
                        "reviewPeriod": 2,
                        "maleAgeMin": 25,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 25,
                        "femaleAgeMax": 60,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Акция!!! Приобретая квартиру площадью 65 кв. м и более, вы получаете доп скидку к ставке: Ставка 10,35%.<br/><br/>При покупке строящегося жилья: личное страхование, страхование объекта после завершения строительства. <br/><br/>Список документов:<br/>1) Паспорт <br/>2) Второй документ: копия Страхового свидетельства государственного пенсионного страхования (для военнослужащих копия Свидетельства о постановке на учет физического лица в налоговом органе)<br/>3) Военный билет для лиц, не достигших 27 лет<br/>4) Копии документов об образовании (аттестаты, дипломы и т.п.); <br/>5) Копия свидетельства о заключении/расторжении брака<br/>6) Копия свидетельств о рождении детей<br/><br/>Для Лен области минимальная сумма кредит 500 тыс рублей.<br/><br/>!!Акция Приобретая квартиру площадью 65 кв. м., вы получаете доп скидку к ставке: по 2ум док-ам ставка 10,35%. при покупке строящегося жилья: личное страхование, страхование объекта после завершения строительства.<br/><br/>При покупке квартиры площадью юолее 100 кв.м ставка 9,95%<br/><br/>",
                        "minPercent": 7.9,
                        "maxPercent": 8.9,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1219,
                        "name": "Строящееся жилье",
                        "xmlId": "abc8d1146f0-7ac8-4611-ad3d-ed49f6d779fc",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 95,
                        "creditMin": 1000000,
                        "creditMax": 60000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Для Лен области минимальная сумма кредит 500 тыс рублей.<br/><br/>Список документов:<br/>1)  Паспорт <br/>2) Второй документ: копия Страхового свидетельства государственного пенсионного страхования (для военнослужащих копия Свидетельства о постановке на учет физического лица в налоговом органе)<br/>3) Военный билет для лиц, не достигших 27 лет<br/>4) Копии документов об образовании (аттестаты, дипломы и т.п.); <br/>5) Копия свидетельства о заключении/расторжении брака<br/>6) Копия свидетельств о рождении детей<br/>7) Копия трудовой книжки, заверенной работодателем. На каждой странице копии: Текущая дата, «копия верна», ФИО, должность, подпись заверившего лица; после последней записи указывается фраза «Работает по настоящее время». при наличии работы по совместительству: копия трудового договора, заверенная работодателем ( так же на каждой странице)<br/>8)  Справка о доходах:<br/>• справка о доходах по форме 2-НДФЛ (в расчет принимается доход за последние 6 месяцев) или<br/>• справка о доходах по форме банка (в расчет принимается доход за последние 6 месяцев) ; В случае, если в штатном расписании должность главного бухгалтера отсутствует, в справке ставятся две подписи руководителя и дополнительно предоставляется заверенная организацией копия приказа о возложении обязанностей главного бухгалтера.<br/>9) Документы, подтверждающие другие регулярные доходы за 6 месяцев с места работы по совместительству<br/><br/> !!!Акция Приобретая квартиру площадью 100 кв. м и более, вы получаете доп скидку к ставке: ставка 8,1% (ПВ при этом от 20%), по 2ум док-ам ставка 8,1%. при покупке строящегося жилья: личное страхование, страхование объекта после завершения строительства. <br/><br/>Если вы работник сферы образования или здравоохранения, правоохранительных или налоговых органов, таможни, органов федерального и муниципального управления, то для вас могут действовать специальные условия - ставка 9,6% (при ПВ от 10%) и ставка 8,6% (при ПВ от 20%)<br/>",
                        "minPercent": 7.9,
                        "maxPercent": 9.9,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1240,
                        "name": "Ипотека господдержка2020",
                        "xmlId": "abc1197d6ab-c30c-4abd-8ff7-798057547de5",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 1000000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Ставка при условии комлпексного страхования (Страховка квартиры: обязательно (оформляется после оформления права собственности)<br/>Страховка жизни и трудоспособности), без комплексного страхования 7,5%. <br/><br/>Срок действия программы до 01.11.2020 г.",
                        "minPercent": 6.5,
                        "maxPercent": 6.5,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 5,
                "maxPeriod": 30,
                "minInitialPayment": 14,
                "formName": "Аккредитация ВТБ в Солнечный город"
            },
            {
                "id": "11862",
                "logo": {
                    "id": 411016,
                    "src": "/upload/resize_cache/iblock/084/300_50_140cd750bba9870f18aada2478b24840a/e121731e87ed96abd413ce23846ce0cf.png",
                    "contentType": "image/png",
                    "width": 236,
                    "height": 50,
                    "description": ""
                },
                "name": "ГАЗПРОМБАНК",
                "xmlId": "abc13",
                "bankPrograms": [
                    {
                        "id": 1159,
                        "name": "Семейная ипотека",
                        "xmlId": "abc36124b69-0543-4511-b267-5a40268d37f5",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 100000,
                        "creditMax": 8000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 20,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "Ипотека c государственной поддержкой для семей, в которых  с 01 января 2018 года по 31 декабря 2022 года родился второй или третий ребенок. <br/><br/>Льготный период: <br/>1) 3 года – при рождении второго ребенка <br/>2) 5 лет – при рождении третьего ребенка<br/><br/>Если третий ребенок родился в течение льготного периода, установленного по кредитному договору (при рождении второго ребенка), льготный период продлевается дополнительно на 5 лет. <br/>Если третий ребенок родился после окончания льготного периода, льготный период возобновляется на 5 лет с даты рождения третьего ребенка.<br/><br/> Требуемые документы: <br/>1) Заявление-анкета на получение ипотечного кредита; <br/>2) оригинал и копия паспорта заемщика (копия всех заполненных страниц общегражданского российского паспорта, включая страницы о семейном положении и наличии/отсутствии детей) или иного документа, удостоверяющего личность; <br/>3) страховое свидетельство государственного пенсионного страхования (достаточно указать страховой номер индивидуального лицевого счета (СНИЛС) в заявлении-анкете); <br/>4) копия трудовой книжки, заверенная (на каждой странице) печатью компании - работодателя; <br/>5) документ, подтверждающий доход*: <br/>- справка по форме 2-НДФЛ; <br/>- оригинал выписки по счету вклада/банковскому счету, открытому в любом банке, содержащей сведения о поступивших перечислениях заработной платы, заверенной подписью должностного лица и печатью/штампом банка;<br/>- справка по форме Банка. <br/>6) документы, подтверждающие право получения кредита в рамках программы «Семейная ипотека»:<br/>свидетельства о рождении всех имеющихся детей (в том числе совершеннолетних) со штампом, подтверждающим гражданство РФ;<br/>документ, подтверждающий гражданство РФ (при отсутствии штампа на свидетельстве о рождении).<br/><br/>В случае расторжения/ не продления договоров страхования в течение периода субсидирования в соответствии с Постановлением №1711: личного страхования и страхования жилого помещения Ставка устанавливается в размере ключевой ставка ЦБ РФ на дату выдачи кредита + 4,0 п.п.<br/><br/>",
                        "minPercent": 5,
                        "maxPercent": 9.25,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1187,
                        "name": "Строящийся дом",
                        "xmlId": "abc6c6919c9-53b6-4bab-a19d-95f975e33aef",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 85,
                        "creditMin": 100000,
                        "creditMax": 60000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 20,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "СТавка действутет при сумме кредита от 10млн. Если сумма кредита от 6 млн - то ставка 8,2%. При сумме кредита до 6 млн - ставка 8,7%. <br/>Надбавка и минусы к ставке: 1) +1 п.п. при отсутствии обеспечения обязательств страхованием (в добровольном порядке) риска смерти заемщика или утраты заемщиком трудоспособности/ риска несчастного случая (полис/ договор страхования не представлен) и титульного страхования (недвижимость с оформленным правом собственности). 2) + 0,3 п.п. для всех заемщиков (кроме зарплатных клиентов Банка ГПБ (АО) или приобретающих квартиру у компаний — партнеров Банка ГПБ (АО) . 3) + 0,5 п. п. если первоначальный взнос менее 20%.<br/><br/>Список документов: <br/>1) заявление-анкета на получение ипотечного кредита;<br/>2) паспорт РФ<br/>3) страховое свидетельство государственного пенсионного страхования <br/>4) копия трудовой книжки, заверенная (на каждой странице) печатью компании - работодателя  <br/>5) документ, подтверждающий доход*:<br/>    - справка по форме 2-НДФЛ;<br/>    - оригинал выписки по счету вклада/банковскому счету, открытому в любом банке, содержащей сведения о поступивших перечислениях заработной платы, заверенной подписью должностного лица и печатью/штампом банка;<br/>    - справка по форме Банка.<br/><br/>При предоставлении сертификата материнского капитала, первоначальный взнос при приобретении квартиры / таунхауса может быть уменьшен на сумму (часть суммы), указанную в сертификате материнского капитала, но не менее чем до 5%.<br/><br/>",
                        "minPercent": 7.5,
                        "maxPercent": 7.8,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1216,
                        "name": "Военная ипотека",
                        "xmlId": "abcffa3c606-dc65-4083-93a9-e2192eb792d0",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 85,
                        "creditMin": 500000,
                        "creditMax": 2746000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Требование : отсутствие у заемщика негативной кредитной истории. <br/><br/>Список документов:<br/>1) Заявление-анкета на получение ипотечного кредита (pdf);<br/>2) Паспорт РФ<br/>3) страховое свидетельство государственного пенсионного страхования <br/>4) свидетельство о праве участника накопительно-ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа;<br/><br/>Документы, подтверждающие доход, не требуются. ",
                        "minPercent": 8.1,
                        "maxPercent": 8.1,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1250,
                        "name": "Льготная ипотека",
                        "xmlId": "abca557e753-fd57-4984-b263-127d1056c1e4",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 100000,
                        "creditMax": 12000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 20,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": "<br/>",
                        "minPercent": 6.1,
                        "maxPercent": 6.1,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 5,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация ГАЗПРОМБАНК в Солнечный город"
            },
            {
                "id": "11878",
                "logo": {
                    "id": 411046,
                    "src": "/upload/resize_cache/iblock/37b/300_50_140cd750bba9870f18aada2478b24840a/uralsib.png",
                    "contentType": "image/png",
                    "width": 244,
                    "height": 50,
                    "description": ""
                },
                "name": "Уралсиб",
                "xmlId": "abc2",
                "bankPrograms": [
                    {
                        "id": 1127,
                        "name": "Строящееся жилье 2 док-та",
                        "xmlId": "abce4f6278e-4f1f-488c-8da5-085c2e1079d0",
                        "initialPaymentMin": 30,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 15000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Надбавки к ставкам: <br/>1) на 1%  в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков;<br/>2) на 1%  в случае приобретения  Индивидуального жилого дома / Квартиры в таунхаусе;<br/>3) на 0,5%  в случае  для Заемщиков – Индивидуальных предпринимателей/собственников бизнеса;<br/>4) на 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка, либо справкой работодателя, выданной по месту работы/прохождения военной службы, военнослужащими, сотрудниками федеральных органов исполнительной власти, сотрудниками Министерства Обороны Российской Федерации, Министерства Внутренних дел Российской Федерации, Министерства Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий, Федеральной службы войск национальной гвардии Российской Федерации, Федеральной Службы безопасности и других «силовых» ведомств (если расчет лимита кредитования производится на основании доходов из справки Банка/организации). <br/>5) на 2%, в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости (для ИП). <br/>6) при сумме кредита более 5 млн - ставка ниже, будет 9,2% <br/>7) плюс 2% при приобретении строящейся недвижимости по предварительному договору купли-продажи .<br/><br/>• При использовании мат капитала - При этом собственные средства Заемщика/Заемщиков  должны составлять не менее 10% от стоимости приобретаемой недвижимости. <br/> <br/>• Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/>",
                        "minPercent": 8.69,
                        "maxPercent": 8.69,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1150,
                        "name": "Легкий старт (2 док-та)",
                        "xmlId": "abc5cdb0cf4-0f7d-432d-af5f-4419527ca409",
                        "initialPaymentMin": 40,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 50000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Если Вы в настоящее время арендуете жилье, но рассматриваете возможность покупки недвижимости с использованием ипотечного кредита в строящихся домах, то программа «Ипотечные каникулы» для Вас!На период, пока ваша квартира строится (от 12 до 24 месяцев) Банк устанавливает для Вас пониженный платеж по кредиту, позволяющий комфортно совмещать платёж по ипотеке и арендные платежи, что в будущем позволит Вам отказаться от аренды жилья в пользу приобретенного жилья.<br/><br/>В рамках программы возможно:<br/>1) платить 50% от общего платежа по ипотеке в период строительства квартиры – период «ипотечных каникул»; <br/>2) в любое время отказаться от «ипотечных каникул» и начать погашение кредита; <br/>3) получить ипотечный кредит по доступной ставке от 12% годовых.<br/><br/>• Для ИП от 30%<br/><br/>Надбавки к процентной ставке: <br/>1) плюс 1% в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков <br/>2) плюс 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка <br/>3) плюс 0,5% для ИП <br/>5) плюс 2% в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости. Возможно использование мат капитала <br/><br/>• Не менее 10% от стоимости приобретаемой недвижимости должно быть внесено  за   счет собственных средств Заемщика/Заемщиков, в случае внесения в качестве первоначального взноса средств (части средств) материнского (семейного) капитала.<br/><br/>• Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/> Получите возможность платить по ипотечному кредиту меньше на этапе строительства. Это позволит вам успешно совмещать аренду жилья и обслуживание ипотеки",
                        "minPercent": 10.49,
                        "maxPercent": 10.49,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1153,
                        "name": "Строящееся (план Доверительный) 2 док-та",
                        "xmlId": "abc0e08d5c6-f1cc-49e1-9b11-4c4c2714a26f",
                        "initialPaymentMin": 40,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 50000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": " Распространяется на клиентов, относящихся к следующим категориям:<br/>­ действующие Заемщики Банка, в том числе по кредитам, права по которым уступлены новому залогодержателю, с положительной кредитной историей;<br/>­ заемщики Банка с положительной кредитной историей по кредитам ПАО «БАНК УРАЛСИБ», в том числе по кредитам, права по которым уступлены новому залогодержателю, погашенным  в течение предшествующих 24-х месяцев (при этом должно быть совершено более 6 платежей в период за последние 24 месяца от текущей даты – это означает, что кредит должен быть погашен не более 18 месяцев назад);<br/>­ клиенты – держатели «зарплатных» карт, эмитированных Банком (пользующиеся картой в течение периода не менее трех месяцев);<br/>­ сотрудники предприятий / организаций бюджетной сферы;<br/>­ сотрудники ГК «Роснефть.<br/><br/>ПВ для ИП от 25%<br/><br/> Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/>Надбавки к ставкам: <br/>1) на 1%  в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков;<br/>2) на 1%  в случае приобретения  Индивидуального жилого дома / Квартиры в таунхаусе;<br/>3) на 0,5%  в случае  для Заемщиков – Индивидуальных предпринимателей/собственников бизнеса;<br/>4) на 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка, либо справкой работодателя, выданной по месту работы/прохождения военной службы, военнослужащими, сотрудниками федеральных органов исполнительной власти, сотрудниками Министерства Обороны Российской Федерации, Министерства Внутренних дел Российской Федерации, Министерства Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий, Федеральной службы войск национальной гвардии Российской Федерации, Федеральной Службы безопасности и других «силовых» ведомств (если расчет лимита кредитования производится на основании доходов из справки Банка/организации). <br/>5) на 2%, в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости (для ИП). <br/>6) при сумме кредита более 5 млн - ставка ниже, будет 9,2% <br/>7) плюс 2% при приобретении строящейся недвижимости по предварительному договору купли-продажи .<br/><br/><br/>• Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/>",
                        "minPercent": 10.2,
                        "maxPercent": 10.2,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1167,
                        "name": "Строящееся (план Доверительный)",
                        "xmlId": "abc03ac8f4f-05b5-49a9-a586-6cb2bceeef10",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 50000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": " Распространяется на клиентов, относящихся к следующим категориям:<br/>­ действующие Заемщики Банка, в том числе по кредитам, права по которым уступлены новому залогодержателю, с положительной кредитной историей;<br/>­ заемщики Банка с положительной кредитной историей по кредитам ПАО «БАНК УРАЛСИБ», в том числе по кредитам, права по которым уступлены новому залогодержателю, погашенным  в течение предшествующих 24-х месяцев (при этом должно быть совершено более 6 платежей в период за последние 24 месяца от текущей даты – это означает, что кредит должен быть погашен не более 18 месяцев назад);<br/>­ клиенты – держатели «зарплатных» карт, эмитированных Банком (пользующиеся картой в течение периода не менее трех месяцев);<br/>­ сотрудники предприятий / организаций бюджетной сферы;<br/>­ сотрудники ГК «Роснефть.<br/><br/>ПВ для ИП от 25%<br/><br/> Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/>Надбавки к ставкам: <br/>1) на 1%  в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков;<br/>2) на 1%  в случае приобретения  Индивидуального жилого дома / Квартиры в таунхаусе;<br/>3) на 0,5%  в случае  для Заемщиков – Индивидуальных предпринимателей/собственников бизнеса;<br/>4) на 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка, либо справкой работодателя, выданной по месту работы/прохождения военной службы, военнослужащими, сотрудниками федеральных органов исполнительной власти, сотрудниками Министерства Обороны Российской Федерации, Министерства Внутренних дел Российской Федерации, Министерства Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий, Федеральной службы войск национальной гвардии Российской Федерации, Федеральной Службы безопасности и других «силовых» ведомств (если расчет лимита кредитования производится на основании доходов из справки Банка/организации). <br/>5) на 2%, в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости (для ИП). <br/>6) при сумме кредита более 5 млн - ставка ниже, будет 9,2%<br/>7) плюс 2% при приобретении строящейся недвижимости по предварительному договору купли-продажи .",
                        "minPercent": 9.7,
                        "maxPercent": 10.2,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1172,
                        "name": "Строящееся для ключевых",
                        "xmlId": "abc7868c51d-8315-4628-992c-7b32b82e1650",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 50000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "При СК до 3 млн ставка 10,3%<br/><br/>Надбавки к ставкам: <br/>1) на 1%  в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков;<br/>2) на 1%  в случае приобретения  Индивидуального жилого дома / Квартиры в таунхаусе;<br/>3) на 0,5%  в случае  для Заемщиков – Индивидуальных предпринимателей/собственников бизнеса;<br/>4) на 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка, либо справкой работодателя, выданной по месту работы/прохождения военной службы, военнослужащими, сотрудниками федеральных органов исполнительной власти, сотрудниками Министерства Обороны Российской Федерации, Министерства Внутренних дел Российской Федерации, Министерства Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий, Федеральной службы войск национальной гвардии Российской Федерации, Федеральной Службы безопасности и других «силовых» ведомств (если расчет лимита кредитования производится на основании доходов из справки Банка/организации). <br/>5) на 2%, в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости (для ИП). <br/>6) при сумме кредита более 5 млн - ставка ниже, будет 9,2% 7) плюс 2% при приобретении строящейся недвижимости по предварительному договору купли-продажи .<br/><br/>• Для ИП ПВ от 25%. <br/><br/>• При использовании мат капитала - При этом собственные средства Заемщика/Заемщиков  должны составлять не менее 10% от стоимости приобретаемой недвижимости. <br/> <br/>• Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/>",
                        "minPercent": 9.7,
                        "maxPercent": 9.7,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1174,
                        "name": "Строящееся жилье",
                        "xmlId": "abc00926149-5104-4ade-ac94-80404cf662d3",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 15000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "При СК до 3 млн ставка 10,5%<br/><br/>Надбавки к ставкам: <br/>1) на 1%  в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков;<br/>2) на 1%  в случае приобретения  Индивидуального жилого дома / Квартиры в таунхаусе;<br/>3) на 0,5%  в случае  для Заемщиков – Индивидуальных предпринимателей/собственников бизнеса;<br/>4) на 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка, либо справкой работодателя, выданной по месту работы/прохождения военной службы, военнослужащими, сотрудниками федеральных органов исполнительной власти, сотрудниками Министерства Обороны Российской Федерации, Министерства Внутренних дел Российской Федерации, Министерства Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий, Федеральной службы войск национальной гвардии Российской Федерации, Федеральной Службы безопасности и других «силовых» ведомств (если расчет лимита кредитования производится на основании доходов из справки Банка/организации). <br/>5) на 2%, в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости (для ИП). <br/>6) при сумме кредита более 5 млн - ставка ниже, будет 9,2% <br/>7) плюс 2% при приобретении строящейся недвижимости по предварительному договору купли-продажи . <br/><br/>Для ИП ПВ от 25%. <br/><br/>• При использовании мат капитала - При этом собственные средства Заемщика/Заемщиков  должны составлять не менее 10% от стоимости приобретаемой недвижимости. <br/> <br/>• Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/>",
                        "minPercent": 8.19,
                        "maxPercent": 9.19,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1184,
                        "name": "Строящееся для ключевых (2 док-та)",
                        "xmlId": "abc97ce1320-bc55-42f0-902e-92688cb8b951",
                        "initialPaymentMin": 30,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 50000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "При СК до 3 млн ставка 10,8%<br/><br/>Надбавки к ставкам: <br/>1) на 1%  в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков;<br/>2) на 1%  в случае приобретения  Индивидуального жилого дома / Квартиры в таунхаусе;<br/>3) на 0,5%  в случае  для Заемщиков – Индивидуальных предпринимателей/собственников бизнеса;<br/>4) на 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка, либо справкой работодателя, выданной по месту работы/прохождения военной службы, военнослужащими, сотрудниками федеральных органов исполнительной власти, сотрудниками Министерства Обороны Российской Федерации, Министерства Внутренних дел Российской Федерации, Министерства Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий, Федеральной службы войск национальной гвардии Российской Федерации, Федеральной Службы безопасности и других «силовых» ведомств (если расчет лимита кредитования производится на основании доходов из справки Банка/организации). <br/>5) на 2%, в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости (для ИП). <br/>6) при сумме кредита более 5 млн - ставка ниже, будет 9,2%<br/>7) плюс 2% при приобретении строящейся недвижимости по предварительному договору купли-продажи .<br/><br/>• Для ИП ПВ от 25%. <br/><br/>• При использовании мат капитала - При этом собственные средства Заемщика/Заемщиков  должны составлять не менее 10% от стоимости приобретаемой недвижимости. <br/> <br/>• Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/>",
                        "minPercent": 10.2,
                        "maxPercent": 10.2,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1193,
                        "name": "Господдержка 2020",
                        "xmlId": "abc84e040fb-2d7c-4d15-8f9a-a2aac5392f0d",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 8000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "<br/><br/>",
                        "minPercent": 6.5,
                        "maxPercent": 6.5,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1208,
                        "name": "Легкий старт",
                        "xmlId": "abcf612d2e6-9076-4f64-8d74-cfacf065cff0",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 50000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Если Вы в настоящее время арендуете жилье, но рассматриваете возможность покупки недвижимости с использованием ипотечного кредита в строящихся домах, то программа «Ипотечные каникулы» для Вас!На период, пока ваша квартира строится (от 12 до 24 месяцев) Банк устанавливает для Вас пониженный платеж по кредиту, позволяющий комфортно совмещать платёж по ипотеке и арендные платежи, что в будущем позволит Вам отказаться от аренды жилья в пользу приобретенного жилья.<br/><br/>При смумме кредита от 5 млн - ставка 9,99%<br/><br/>В рамках программы возможно:<br/>1) платить 50% от общего платежа по ипотеке в период строительства квартиры – период «ипотечных каникул»; <br/>2) в любое время отказаться от «ипотечных каникул» и начать погашение кредита; <br/>3) получить ипотечный кредит по доступной ставке от 12% годовых.Для ИП от 30%<br/><br/>Надбавки к процентной ставке: <br/>1) плюс 1% в случае предоставления кредита без заключения договора страхования жизни и риска потери трудоспособности Заемщика/Заемщиков <br/>2) плюс 0,5% в случае выдачи кредита без  подтверждения Заемщиком/Заемщиками доходов справкой по форме 2-НДФЛ, либо выпиской по зарплатному картсчету Заемщика для держателей «зарплатных» карт Банка <br/>3) плюс 0,5% для ИП<br/>4) плюс 2% в случае если  по  истечении  3 (трех)  лет   с момента выдачи кредита не оформлено право собственности  на  приобретенный объект недвижимости. Возможно использование мат капитала <br/><br/>Не менее 10% от стоимости приобретаемой недвижимости должно быть внесено  за   счет собственных средств Заемщика/Заемщиков, в случае внесения в качестве первоначального взноса средств (части средств) материнского (семейного) капитала.<br/><br/> Максимальный возраст на момент окончания срока кредита – 70 лет (в случае если возраст заемщика на момент окончания срока кредитования будет превышать 65 лет – требуется привлечение созаемщика, который на момент окончания срока кредитования не достигнет пенсионного возраста). <br/><br/> Получите возможность платить по ипотечному кредиту меньше на этапе строительства. Это позволит вам успешно совмещать аренду жилья и обслуживание ипотеки",
                        "minPercent": 9.99,
                        "maxPercent": 9.99,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1229,
                        "name": "Господдержка",
                        "xmlId": "abc15ff3257-08e5-4b82-9d31-0ae3480dca02",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Наличие 2-х и более детей, второй и последующие дети должны быть рождены не ранее 01.01.2018. Кредит предоставляется гражданам Российской Федерации при рождении у них начиная с 1 января 2018 г. и не позднее 31 декабря 2022 г. второго ребенка и (или) последующих детей, являющихся гражданами Российской Федерации на: приобретение квартиры в многоквартирном доме или таунхаусе у юридического лица (за исключением<br/>инвестиционного фонда, в том числе его управляющей компании) на первичном рынке жилья по договору участия в долевом строительстве",
                        "minPercent": 5.5,
                        "maxPercent": 5.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1230,
                        "name": "Господдержка",
                        "xmlId": "abca8c32e28-2b1a-4770-9adb-3877641b1112",
                        "initialPaymentMin": 40,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 18,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Наличие 2-х и более детей, второй и последующие дети должны быть рождены не ранее 01.01.2018. Кредит предоставляется гражданам Российской Федерации при рождении у них начиная с 1 января 2018 г. и не позднее 31 декабря 2022 г. второго ребенка и (или) последующих детей, являющихся гражданами Российской Федерации на: приобретение квартиры в многоквартирном доме или таунхаусе у юридического лица (за исключением<br/>инвестиционного фонда, в том числе его управляющей компании) на первичном рынке жилья по договору участия в долевом строительстве",
                        "minPercent": 5.5,
                        "maxPercent": 5.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 5.5,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация Уралсиб в Солнечный город"
            },
            {
                "id": "11859",
                "logo": {
                    "id": 411010,
                    "src": "/upload/resize_cache/iblock/767/300_50_140cd750bba9870f18aada2478b24840a/logotip-bank-rossiya.png",
                    "contentType": "image/png",
                    "width": 252,
                    "height": 50,
                    "description": ""
                },
                "name": "Банк Россия",
                "xmlId": "abc73",
                "bankPrograms": [
                    {
                        "id": 1148,
                        "name": "Без Первого взноса",
                        "xmlId": "abc8c5d3a6b-f583-4eae-b565-3d38347300de",
                        "initialPaymentMin": 0,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 25,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 25,
                        "femaleAgeMax": 60,
                        "totalPeriod": 36,
                        "employeePeriod": 6,
                        "businessPeriod": 36,
                        "requirements": "Обязательное условие - длительность периода до готовности к сдаче дома Государственной комиссии по приемке объектов строительства – не менее 10 (месяцев) с даты подачи Заемщиком/Созаемщиком заявки на кредит в Банк. Обязательное наличие 3 (трех) контактных телефонных номеров – рабочего, домашнего и мобильного телефонов (в случае отсутствия домашнего телефона, обязательное предоставление мобильного или домашнего телефона, по которому возможно подтвердить личность Заемщика и который может быть контактным телефоном Заемщика). Супруг(а) Заемщика в обязательном порядке выступает Созаемщиком по кредиту .вне зависимости от наличия источника и размера дохода (за исключением случаев наличия действующего брачного договора, предусматривающего раздельный.<br/><br/>• Заемщиком/Созаемщиком/Поручителем не может выступать: ИП, работник ИП, собственник бизнеса.<br/><br/>• Для работников бюжетных организаций - ставка 11,5%. <br/><br/>Надбавки к процентной ставке: <br/>1) Отсутствие страхования жизни и здоровья Заемщика/ Созаемщика(ов) - плюс 1%<br/>2) Заемщик не получает заработную плату на счет, открытый в Банкe - плюс 0,2%.",
                        "minPercent": 12.5,
                        "maxPercent": 12.5,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1173,
                        "name": "Новые метры",
                        "xmlId": "abc50a0e1cd-b802-4df3-805e-7e7524556a32",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 85,
                        "creditMin": 300000,
                        "creditMax": 30000000,
                        "reviewPeriod": 14,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 60,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": " Надбавки: 1)  отсутствие страхования жизни и здоровья Заемщика/ созаемщика - плюс 0,5% 2)При покупке квартиры более 60 метров - ставка 7,75% 3)при сумме кредита свыше 7 млн - ставка 7,75%. Заемщиком/Созаемщиком/Поручителем не может выступать: индивидуальный предприниматель; работник индивидуального предпринимателя; собственник бизнеса. ",
                        "minPercent": 7.75,
                        "maxPercent": 7.95,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1220,
                        "name": "Военная ипотека",
                        "xmlId": "abc1c44dcbd-8302-4e38-81d4-ee5f195c181a",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 85,
                        "creditMin": 300000,
                        "creditMax": 3270000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 20,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 45,
                        "totalPeriod": 12,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Кредит предоставляется военнослужащим, являющимся участниками НИС, имеющим право на получение целевого жилищного займа на основании Федерального закона «О накопительно-ипотечной системе жилищного обеспечения военнослужащих» №117-ФЗ от 20.08.2004г. на приобретение квартиры.<br/><br/>Требования к заемщику:<br/>1) Гражданин РФ, являющийся резидентом РФ.<br/>2) Военнослужащий, проходящий военную службу, включенный в реестр Участников НИС и имеющий соответствующее свидетельство.<br/>3) Возраст от 20 лет, полное погашение кредита должно быть осуществлено до исполнения Заемщику 45 лет.<br/>4) Постоянно или временно (не менее 6 месяцев) проживающий и зарегистрированный в РФ.<br/>5) Участие в НИС не менее 3-х лет.<br/><br/>Перечень документов: <br/>1) Заявление-Анкета на получение кредита;<br/>2) Паспорт гражданина РФ;<br/>3) Свидетельство о праве участника накопительно - ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа (оригинал/копия);<br/>4) Страховое свидетельство государственного пенсионного страхования (при наличии).",
                        "minPercent": 7.5,
                        "maxPercent": 7.5,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1249,
                        "name": "Военная ипотека с господдержкой",
                        "xmlId": "abc27cbcd08-98d8-4523-a561-0016b6a6a3d0",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 85,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 3,
                        "maleAgeMin": 20,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 20,
                        "femaleAgeMax": 45,
                        "totalPeriod": 12,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Кредит предоставляется военнослужащим, являющимся участниками НИС, имеющим право на получение целевого жилищного займа на основании Федерального закона «О накопительно-ипотечной системе жилищного обеспечения военнослужащих» №117-ФЗ от 20.08.2004г. на приобретение квартиры.<br/><br/>Требования к заемщику:<br/>1) Гражданин РФ, являющийся резидентом РФ.<br/>2) Военнослужащий, проходящий военную службу, включенный в реестр Участников НИС и имеющий соответствующее свидетельство.<br/>3) Возраст от 20 лет, полное погашение кредита должно быть осуществлено до исполнения Заемщику 45 лет.<br/>4) Постоянно или временно (не менее 6 месяцев) проживающий и зарегистрированный в РФ.<br/>5) Участие в НИС не менее 3-х лет.<br/><br/>Перечень документов: <br/>1) Заявление-Анкета на получение кредита;<br/>2) Паспорт гражданина РФ;<br/>3) Свидетельство о праве участника накопительно - ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа (оригинал/копия);<br/>4) Страховое свидетельство государственного пенсионного страхования (при наличии).",
                        "minPercent": 5.75,
                        "maxPercent": 5.75,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1258,
                        "name": "Новые метр с господдержкой",
                        "xmlId": "abcef1b41b6-1d44-4a2b-bce3-7778eb236e69",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 85,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 14,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 60,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "",
                        "minPercent": 6,
                        "maxPercent": 6,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    }
                ],
                "minPercent": 5.75,
                "maxPeriod": 25,
                "minInitialPayment": 25,
                "formName": "Аккредитация Банк Россия в Солнечный город"
            },
            {
                "id": "11877",
                "logo": {
                    "id": 411044,
                    "src": "/upload/resize_cache/iblock/9f8/300_50_140cd750bba9870f18aada2478b24840a/l3.jpg",
                    "contentType": "image/jpeg",
                    "width": 176,
                    "height": 50,
                    "description": ""
                },
                "name": "ТрансКапиталБанк",
                "xmlId": "abc81",
                "bankPrograms": [
                    {
                        "id": 1155,
                        "name": "Первичный рынок",
                        "xmlId": "abcdee29ef3-e8bb-42a4-a5b6-4ec0182ebfa8",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Возможно Использование материнского капитала в качестве первоначального взноса.  <br/><br/>ПВ от 5% возможен только при сумме кредита не более 6 млн.<br/><br/>Минимальная СК при использовании мат капитала 800 тыс.<br/><br/>Список документов: <br/>1. Заявление-анкета.<br/>2. Паспорт гражданина РФ, либо паспорт иностранного государства (предоставляется всеми участниками сделки и лицами, оформляющими согласие на предоставление кредита) <br/>3. Справка о доходах по форме № 2-НДФЛ, либо справка по форме Банка, заверенные организацией-работодателем не менее чем за последние 3 мес.<br/>4. Заверенная организацией-работодателем копия трудовой книжки. В случае отсутствия трудовой книжки:<br/>- служащие МО, МВД, ФСБ, ФСО и других структур предоставляют заверенную копию контракта соответствующим ведомством/ Справку, подтверждающую прохождение службы<br/>- в случае работы по договорам гражданско-правового характера – заверенная работодателем копия договора,<br/>- в случае работы в представительстве иностранной компании по контракту – заверенная представительством копия контракта.<br/> <br/>Для ИП документы: <br/>1) Паспорт гражданина РФ <br/>2) Заявление-анкета <br/>3) Свидетельство о регистрации (ОГРН) <br/>4) Лицензии (нотариусов), патенты (при наличии)<br/>5) Налоговая декларация за 2 предыдущих отчетных периода или справка по форме Банка за 6 месяцев <br/>6) Справка по форме НДФЛ, либо платежные (расчетные) документы, подтверждающие факт получения дивидендов <br/>7) Свидетельство о присвоении ИНН <br/>8) Удостоверение адвоката (только для адвокатов). <br/><br/>При использовании мат капитала - ПВ от 800 тыс. и минимальный ПВ 5%. <br/><br/>Надбавки к процентной ставке: <br/>1) плюс 0,75% - если справка о ЗП по форме банка <br/>2) если ИП или собственник бизнеса +0,5% <br/>3) если стаж работы ен соответсвует требованиям плюс 0,25% <br/>4) если кредит без страхования жизни и риска потери трудоспособности - то процентная ставка повышается на 2,5%<br/>5) плюс 1% -при отмене страхования титула передаваемого в залог имущества.<br/><br/>Возможно снижение процентной ставки при применении тарифа: <br/>1) практичный - снижение ставки на 0,5%(стоит 1,5% от суммы кредита) <br/>2) сбалансированный - снижение ставки на 1% (стоит 3% от суммы кредита <br/>3) выгодный - снижение на 1,5% (стоит 4,5% от суммы кредита. Для ИП и собсвенников бизнеса по 2-ум док-ам запрещено подавать заявку.<br/><br/>ПРИ  СК более 12 млн - ставки: ПВ от 35% - 11,45%, ПВ от 50% - 11,2%.",
                        "minPercent": 8.99,
                        "maxPercent": 10.2,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1157,
                        "name": "Ипотека в полузнках",
                        "xmlId": "abc77aa30e6-e830-48d2-9e84-5931b89a6092",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Обязательным условием предоставления кредита является рождение второго или третьего ребенка в период действия программы с 01.01.2018 по 31.12.2022 г.<br/><br/> При рождении второго ребенка в период действия программы ставка по кредиту составит 6% годовых на 3 года, при рождении третьего ребенка – 6% годовых на 5 лет.  <br/>В случае рождения (в Период действия программы) у клиента, третьего ребенка и при условии действующего периода предусмотренного п. 2, Льготный период пролонгируется на 5 лет, при этом:<br/>- в случае непредоставления свидетельства о рождении третьего ребенка до даты окончания действия периода предусмотренного п. 2, размер процентной ставки устанавливается в соответствии со ставкой Периода кредитования 2 со дня, следующего за датой окончания периода предусмотренного п. 2.<br/>- в случае предоставления в Банк свидетельства о рождении третьего ребенка в Период кредитования 2, снижение процентной ставки до уровня, установленного для Льготного периода. <br/><br/>При рождении в (Период действия программы) у клиента, третьего ребенка после окончания периода предусмотренного п. 2, Льготный период пролонгируется на 5 лет с даты рождения третьего ребенка, однако снижение процентной ставки до уровня, установленного для Льготного периода, происходит в дату ежемесячного платежа, следующую за датой предоставления свидетельства о рождении третьего ребенка в Банк. ",
                        "minPercent": 5.9,
                        "maxPercent": 9.25,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1161,
                        "name": "Первичный рынок (2 док-та)",
                        "xmlId": "abcbe3af4f6-c8b3-45c8-a599-5fb7af9fc557",
                        "initialPaymentMin": 30,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Возможно Использование материнского капитала в качестве первоначального взноса. <br/> <br/>Список документов: <br/>1. Заявление-анкета с обязательным предоставлением ИНН работодателя.<br/>2. Паспорт гражданина РФ, либо паспорт иностранного государства (предоставляется всеми совершеннолетними участниками сделки)<br/><br/> При использовании мат капитала - ПВ от 800 тыс.<br/><br/>Надбавки к процентной ставке: <br/>1) если ИП или собственник бизнеса +0,5% <br/>2) если стаж работы не соответсвует требованиям плюс 0,25% <br/>3) Если кредит без страхования жизни и риска потери трудоспособности - то процентная ставка повышается на 2,5% <br/>4) плюс 1% -при отмене страхования титула передаваемого в залог имущества.<br/><br/> Возможно снижение процентной ставки при применении тарифа: <br/>1) практичный - снижение ставки на 0,5%(стоит 1,5% от суммы кредита)<br/>2) сбалансированный - снижение ставки на 1% (стоит 3% от суммы кредита <br/>3) выгодный - снижение на 1,5% (стоит 4,5% от суммы кредита. Для ИП и собсвенников бизнеса по 2-ум док-ам запрещено подавать заявку.<br/><br/>ПРИ  СК более 12 млн - ставки: ПВ от 35% - 11,4%, ПВ от 50% - 10,9%.",
                        "minPercent": 9.49,
                        "maxPercent": 10.7,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1192,
                        "name": "Иптека в полузнках (2 док-та)",
                        "xmlId": "abc822f3b1e-bc10-4718-a562-9ffd0e00df0f",
                        "initialPaymentMin": 50,
                        "initialPaymentMax": 90,
                        "creditMin": 500000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Обязательным условием предоставления кредита является рождение второго или третьего ребенка в период действия программы с 01.01.2018 по 31.12.2022 г.<br/><br/> При рождении второго ребенка в период действия программы ставка по кредиту составит 6% годовых на 3 года, при рождении третьего ребенка – 6% годовых на 5 лет.  <br/>В случае рождения (в Период действия программы) у клиента, третьего ребенка и при условии действующего периода предусмотренного п. 2, Льготный период пролонгируется на 5 лет, при этом:<br/>- в случае непредоставления свидетельства о рождении третьего ребенка до даты окончания действия периода предусмотренного п. 2, размер процентной ставки устанавливается в соответствии со ставкой Периода кредитования 2 со дня, следующего за датой окончания периода предусмотренного п. 2.<br/>- в случае предоставления в Банк свидетельства о рождении третьего ребенка в Период кредитования 2, снижение процентной ставки до уровня, установленного для Льготного периода. <br/><br/>При рождении в (Период действия программы) у клиента, третьего ребенка после окончания периода предусмотренного п. 2, Льготный период пролонгируется на 5 лет с даты рождения третьего ребенка, однако снижение процентной ставки до уровня, установленного для Льготного периода, происходит в дату ежемесячного платежа, следующую за датой предоставления свидетельства о рождении третьего ребенка в Банк. ",
                        "minPercent": 5.9,
                        "maxPercent": 9.25,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1259,
                        "name": "Госпрограмма 2020",
                        "xmlId": "abccf91af93-4e8d-40b6-b315-af5480c7f6bf",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 90,
                        "creditMin": 1000000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 75,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 75,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Возможно Использование материнского капитала в качестве первоначального взноса.  <br/><br/>ПВ от 5% возможен только при сумме кредита не более 6 млн.<br/><br/>Минимальная СК при использовании мат капитала 800 тыс.<br/><br/>Список документов: <br/>1. Заявление-анкета.<br/>2. Паспорт гражданина РФ, либо паспорт иностранного государства (предоставляется всеми участниками сделки и лицами, оформляющими согласие на предоставление кредита) <br/>3. Справка о доходах по форме № 2-НДФЛ, либо справка по форме Банка, заверенные организацией-работодателем не менее чем за последние 3 мес.<br/>4. Заверенная организацией-работодателем копия трудовой книжки. В случае отсутствия трудовой книжки:<br/>- служащие МО, МВД, ФСБ, ФСО и других структур предоставляют заверенную копию контракта соответствующим ведомством/ Справку, подтверждающую прохождение службы<br/>- в случае работы по договорам гражданско-правового характера – заверенная работодателем копия договора,<br/>- в случае работы в представительстве иностранной компании по контракту – заверенная представительством копия контракта.<br/> <br/>Для ИП документы: <br/>1) Паспорт гражданина РФ <br/>2) Заявление-анкета <br/>3) Свидетельство о регистрации (ОГРН) <br/>4) Лицензии (нотариусов), патенты (при наличии)<br/>5) Налоговая декларация за 2 предыдущих отчетных периода или справка по форме Банка за 6 месяцев <br/>6) Справка по форме НДФЛ, либо платежные (расчетные) документы, подтверждающие факт получения дивидендов <br/>7) Свидетельство о присвоении ИНН <br/>8) Удостоверение адвоката (только для адвокатов). <br/><br/>При использовании мат капитала - ПВ от 800 тыс. и минимальный ПВ 5%. <br/><br/>Надбавки к процентной ставке: <br/>1) плюс 0,75% - если справка о ЗП по форме банка <br/>2) если ИП или собственник бизнеса +0,5% <br/>3) если стаж работы ен соответсвует требованиям плюс 0,25% <br/>4) если кредит без страхования жизни и риска потери трудоспособности - то процентная ставка повышается на 2,5%<br/>5) плюс 1% -при отмене страхования титула передаваемого в залог имущества.<br/><br/>Возможно снижение процентной ставки при применении тарифа: <br/>1) практичный - снижение ставки на 0,5%(стоит 1,5% от суммы кредита) <br/>2) сбалансированный - снижение ставки на 1% (стоит 3% от суммы кредита <br/>3) выгодный - снижение на 1,5% (стоит 4,5% от суммы кредита. Для ИП и собсвенников бизнеса по 2-ум док-ам запрещено подавать заявку.<br/><br/>Для ИП и собственников бизнеса не менее 40%",
                        "minPercent": 6.49,
                        "maxPercent": 6.49,
                        "minPeriod": 90,
                        "maxPeriod": 90
                    }
                ],
                "buildings": [
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    }
                ],
                "minPercent": 5.9,
                "maxPeriod": 90,
                "minInitialPayment": 25,
                "formName": "Аккредитация ТрансКапиталБанк в Солнечный город"
            },
            {
                "id": "59009",
                "logo": false,
                "name": "Московский Кредитный Банк",
                "xmlId": "abc93",
                "bankPrograms": [
                    {
                        "id": 1261,
                        "name": "Льготная ипотека",
                        "xmlId": "abcea13a4b3-ad36-4907-a80c-065b93db788a",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 700000,
                        "creditMax": 12000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 60,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": " Ставка устанавливается после государственной регистрации залога прав требований по договору участия в долевом строительстве / договору уступки прав требования либо залога жилого помещения по договору купли-продажи, до момента регистрации — 7,25%.<br/><br/>Ставка увеличивается на 1 п. п.:<br/>При отказе клиента от страхования, при страховании только риска утраты / гибели или повреждения предмета залога (имущественное страхование); при незаключении, расторжении полиса ипотечного страхования либо непредоставлении документов, подтверждающих уплату очередной страховой премии по полису ипотечного страхования по риску утраты / гибели или повреждения предмета залога (имущественное страхование);<br/><br/>при страховании только по риску причинения вреда жизни и потери трудоспособности Заемщика (Созаемщика (ов) — если применимо); при незаключении, расторжении полиса ипотечного страхования либо непредоставлении документов, подтверждающих уплату очередной страховой премии по полису ипотечного страхования по риску причинения вреда жизни и потери трудоспособности Заемщика (Созаемщика (ов) — если применимо);<br/><br/>при страховании только по риску утраты предмета залога в результате прекращения и/или ограничения права собственности (титула); при незаключении, расторжении полиса ипотечного страхования либо непредоставлении документов, подтверждающих уплату очередной страховой премии по полису ипотечного страхования по риску утраты предмета залога в результате прекращения и/или ограничения права собственности (титула).",
                        "minPercent": 5.95,
                        "maxPercent": 5.95,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1262,
                        "name": "Ипотека",
                        "xmlId": "abc129e6277-6ee6-41d4-8ccc-426e95f319f3",
                        "initialPaymentMin": 10,
                        "initialPaymentMax": 90,
                        "creditMin": 100000,
                        "creditMax": 30000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 60,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "",
                        "minPercent": 7.5,
                        "maxPercent": 8.6,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1263,
                        "name": "Ипотека для семей с детьми",
                        "xmlId": "abc85201003-dbd3-47d8-aeb5-7c56afe037ef",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 700000,
                        "creditMax": 12000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 60,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "",
                        "minPercent": 6,
                        "maxPercent": 6,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    }
                ],
                "minPercent": 5.95,
                "maxPeriod": 30,
                "minInitialPayment": 30,
                "formName": "Аккредитация Московский Кредитный Банк в Солнечный город"
            },
            {
                "id": "26922",
                "logo": {
                    "id": 410962,
                    "src": "/upload/resize_cache/iblock/c28/300_50_140cd750bba9870f18aada2478b24840a/alfa.jpg",
                    "contentType": "image/jpeg",
                    "width": 168,
                    "height": 50,
                    "description": ""
                },
                "name": "Альфа-Банк",
                "xmlId": "abc90",
                "bankPrograms": [
                    {
                        "id": 1197,
                        "name": "Новостройка",
                        "xmlId": "abcc9d0b3f3-db50-4b76-a824-b1ea81bdeb7a",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 90,
                        "creditMin": 600000,
                        "creditMax": 20000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Что уменьшает ставку (скидка от базовой ставки, скидки не суммируются: <br/>1) -0,3% Покупка недвижимости у ключевого партнера Альфа-Банка<br/> 2) -0,4% Покупка недвижимости у Exclusive-партнера Альфа-Банка <br/>3) -0,7% Зарплатным клиентам Альфа-Банка и Клиентам A-Private <br/>4) -0,7% Клиентам A-Private <br/>5) -0,4% за выход на сделку в течение 30 календарных дней после одобрения кредита (суммируется с остальными скидками)<br/><br/>Увеличивает (надбавки к базовой ставке, могут суммироваться):<br/> 1) +0,5% — ипотека по 2-м документам. <br/>2) +1% — для ИП и собственников бизнеса <br/>3) +2% — отказ от страхования жизни.<br/>4) +2% — отказ от страхования титула <br/>5) +4% - отказ от страхования жизни и титула. <br/><br/>Для оплаты взноса можно использовать материнский капитал. Но не менее 10% всей стоимости недвижимости нужно внести своими деньгами.",
                        "minPercent": 8.79,
                        "maxPercent": 9.39,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1205,
                        "name": "Новостройка (2 док-та)",
                        "xmlId": "abc5bc274cd-96c3-4619-a885-cbb645bbfb35",
                        "initialPaymentMin": 50,
                        "initialPaymentMax": 90,
                        "creditMin": 600000,
                        "creditMax": 20000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Что уменьшает ставку (скидка от базовой ставки, скидки не суммируются: <br/>1) -0,3% Покупка недвижимости у ключевого партнера Альфа-Банка<br/> 2) -0,4% Покупка недвижимости у Exclusive-партнера Альфа-Банка <br/>3) -0,7% Зарплатным клиентам Альфа-Банка и Клиентам A-Private <br/>4) -0,7% Клиентам A-Private <br/>5) -0,4% за выход на сделку в течение 30 календарных дней после одобрения кредита (суммируется с остальными скидками)<br/><br/>Увеличивает (надбавки к базовой ставке, могут суммироваться):<br/> 1) +0,5% — ипотека по 2-м документам. <br/>2) +1% — для ИП и собственников бизнеса <br/>3) +2% — отказ от страхования жизни.<br/>4) +2% — отказ от страхования титула <br/>5) +4% - отказ от страхования жизни и титула. <br/><br/>Для оплаты взноса можно использовать материнский капитал. Но не менее 10% всей стоимости недвижимости нужно внести своими деньгами.",
                        "minPercent": 9.29,
                        "maxPercent": 9.29,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1242,
                        "name": "Господдержка 20202",
                        "xmlId": "abc0fd4ad4d-afd5-4ce1-a643-b2f278aaa0ac",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 600000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "<br/>Для оплаты взноса можно использовать материнский капитал. Но не менее 10% всей стоимости недвижимости нужно внести своими деньгами.<br/><br/>ставка 5,99% при сумме кредита от 5 млн, ставка 6,19%при сумме кредита  менее 5 млн",
                        "minPercent": 5.99,
                        "maxPercent": 5.99,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 5.99,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация Альфа-Банк в Солнечный город"
            },
            {
                "id": "11879",
                "logo": {
                    "id": 410998,
                    "src": "/upload/resize_cache/iblock/33d/300_50_140cd750bba9870f18aada2478b24840a/2127.png",
                    "contentType": "image/png",
                    "width": 177,
                    "height": 49,
                    "description": ""
                },
                "name": "Юникредитбанк",
                "xmlId": "abc20",
                "bankPrograms": [
                    {
                        "id": 1181,
                        "name": "Ипотека с господдержкой для семей с детьми",
                        "xmlId": "abc32038f98-7dbf-4615-bab5-90e8697b5161",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 80,
                        "creditMin": 1000000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 60,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 55,
                        "totalPeriod": 24,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Программа распространяется на граждан РФ при условии рождения у них второго, третьего и (или) последующих детей, имеющих гражданство РФ, начиная с 01.01.2018 по 31.12.2022 г.<br/><br/>Средства материнского капитала не могут быть учтены в качестве первоначального взноса. <br/><br/>Скидки и надбавки к процентным ставкам:<br/>При отсутствии страхования рисков причинения вреда жизни и постоянной потери трудоспособности заемщика и поручителя(-ей) участвующего(-их) доходами, устанавливается процентная ставка в размере ключевой процентной ставки на дату выдачи кредита +4,5%.",
                        "minPercent": 6,
                        "maxPercent": 9.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1206,
                        "name": "Новостройка",
                        "xmlId": "abc2d77eefa-4a4f-4aee-a374-cc47f58dc577",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 85,
                        "creditMin": 250000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 60,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 55,
                        "totalPeriod": 24,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Первоначальный взнос может быть уменьшен на сумму материнского капитала для кредита в рублях. <br/><br/>Скидки и надбавки к процентным ставкам:<br/>?0,50% Для зарплатных клиентов2 Банка.<br/>?0,50% При предоставлении заявления и пакета документов для рассмотрения возможности предоставления кредита под залог недвижимого имущества через Информационный центр Банка.<br/>?0,50% При оформлении расширенного договора страхования «Премиум»3 для программы «Кредит на покупку квартиры на первичном рынке жилья».<br/>?0,20% При оформлении расширенного договора страхования «Стандарт»4 для программы «Кредит на покупку квартиры на первичном рынке жилья».<br/>?0,25% — при сумме кредита 3 000 000 ? и более<br/>?0,50% — при сумме кредита 4 500 000 ? и более<br/>+1,00% При отсутствии страхования риска потери предмета залога в результате прекращения права собственности на него (титульное право) в случае, если данный вид страхования предусмотрен программой кредитования.<br/>+2,50% При отсутствии и не предоставлении в Банк страхования рисков причинения вреда жизни и постоянной потери трудоспособности заемщика или поручителя(-ей) участвующего(-их) доходами, а равно, заключения договора страхования со страховой организацией, не соответствующей требованиям Банка и/или исключенной из Перечня страховых организаций, соответствующих требованиям Банка",
                        "minPercent": 8.9,
                        "maxPercent": 8.9,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    }
                ],
                "minPercent": 6,
                "maxPeriod": 30,
                "minInitialPayment": 30,
                "formName": "Аккредитация Юникредитбанк в Солнечный город"
            },
            {
                "id": "11876",
                "logo": {
                    "id": 411042,
                    "src": "/upload/resize_cache/iblock/029/300_50_140cd750bba9870f18aada2478b24840a/bb22548f9f22948bbe9c1bd9e404dfc6.png",
                    "contentType": "image/png",
                    "width": 88,
                    "height": 50,
                    "description": ""
                },
                "name": "Сургутнефтегаз",
                "xmlId": "abc79",
                "bankPrograms": [
                    {
                        "id": 1204,
                        "name": "Все просто",
                        "xmlId": "abcd6ebe224-a3fa-474f-95fc-c9bcad7ccbe8",
                        "initialPaymentMin": 50,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 15000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 6,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "*Размер процентов за пользование кредитом увеличивается на 2%: <br/>1) cо дня, следующего за днем выдачи Кредита, и до дня представления Заемщиком документов, подтверждающих исполнение условий по передаче Жилья/Нежилого помещения в залог Банку (далее – имущество), и условия по личному страхованию от несчастных случаев, болезней, потери дохода (далее – личное страхование), либо по день возврата суммы основного долга по Кредиту (включительно).<br/><br/>Размер процентов за пользование кредитом увеличивается на 1%: <br/>1) со дня, следующего за днем представления Заемщиком документов, подтверждающих исполнение условия по передаче имущества в залог Банку, и при отсутствии личного страхования, и до дня представления Заемщиком документов, подтверждающих исполнение условий по личному страхованию, либо по день возврата суммы основного долга по Кредиту (включительно);<br/>со дня, следующего за днем представления Заемщиком документов, подтверждающих исполнение условия по личному страхованию (его продлению) и при отсутствии залога имущества, и до дня представления Заемщиком документов, подтверждающих исполнение условий по передаче имущества в залог Банку, либо по день возврата суммы основного долга по Кредиту (включительно); <br/>2) cо дня, следующего за днем истечения периодов личного страхования, и до дня представления Заемщиком документов, подтверждающих их продление (включительно), либо по день возврата суммы основного долга по Кредиту (включительно).<br/>Cтавка снижается на 0,1% при электронной регистрации сделки.<br/><br/><br/>Cтавка снижается на 0,1% при электронной регистрации сделки. Кредит доступен для Клиентов, находящихся на обслуживании в блоке «Премиальный банкинг».",
                        "minPercent": 10.5,
                        "maxPercent": 10.5,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1232,
                        "name": "Ипотека для семей с детьми",
                        "xmlId": "abc40da1f7e-50a2-43b3-a857-bf3440dcb10d",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 6,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "ставка 5% Со дня, следующего за днем представления Заемщиком документов, подтверждающих исполнение либо продление условий по личному страхованию и страхованию Недвижимого имущества, и до дня истечения периодов страхования недвижимого имущества и (или) личного страхования (включительно).  Для зарплатных Клиентов / зарплатных Клиентов «бюджетников» размер процентной ставки снижается на 0,2% годовых.<br/>",
                        "minPercent": 7.8,
                        "maxPercent": 7.8,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1254,
                        "name": "Госпрограмма 2020",
                        "xmlId": "abc03fd3710-6c09-4764-88cd-3c51a2ccccee",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 300000,
                        "creditMax": 12000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 70,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 70,
                        "totalPeriod": 6,
                        "employeePeriod": 6,
                        "businessPeriod": 12,
                        "requirements": "Для зарплатных Клиентов / зарплатных Клиентов «бюджетников» размер процентной ставки снижается на:<br/>- 0,5% годовых;<br/>- 0,9% годовых по заявкам, принятым в период с 16.12.2019 до 31.01.2020 (включительно). <br/><br/>Аккредитованные застройщики: Самолет ЛО, Бонава, ЛенСпецсму, Полис Групп, Лидер С-З, ЛСР,ЦДС<br/>",
                        "minPercent": 6.4,
                        "maxPercent": 6.4,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    }
                ],
                "minPercent": 6.4,
                "maxPeriod": 30,
                "minInitialPayment": 30,
                "formName": "Аккредитация Сургутнефтегаз в Солнечный город"
            },
            {
                "id": "11867",
                "logo": {
                    "id": 411030,
                    "src": "/upload/resize_cache/iblock/64b/300_50_140cd750bba9870f18aada2478b24840a/n_logo_1.png",
                    "contentType": "image/png",
                    "width": 199,
                    "height": 50,
                    "description": ""
                },
                "name": "Московский Индустриальный Банк",
                "xmlId": "abc82",
                "bankPrograms": [
                    {
                        "id": 1145,
                        "name": "Новостройка (2 док-та)",
                        "xmlId": "abccda39baf-30ae-4612-bc80-3037a7727ade",
                        "initialPaymentMin": 50,
                        "initialPaymentMax": 80,
                        "creditMin": 100000,
                        "creditMax": 8000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 22,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 22,
                        "femaleAgeMax": 65,
                        "totalPeriod": 6,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Обязательное условие -   страхование недвижимости в пользу банка на срок кредитования. При отсутствии личного страхования заемщика процентная ставка увеличивается на 4%.<br/><br/> Список документов: <br/>1) Паспорт РФ <br/>2) Второй документ (по выбору клиента): заграничный паспорт, водительское удостоверение, свидетельство о пенсионном страховании, свидетельство о присвоении ИНН, пенсионное удостоверение. <br/><br/><br/>Воспользуйтесь услугой «Снижение ставки», чтобы снизить процент по ипотеке на 0,5% - 1,5%: <br/>1) скидка 0,5% - комиссионное вознаграждение 1,6% от СК <br/>2) скидка 1% - комиссионное вознаграждение 3,2% от СК <br/>3) скидка 1,5% - комиссионное вознаграждение 4,8% от СК",
                        "minPercent": 9.2,
                        "maxPercent": 9.2,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1182,
                        "name": "Новостройка",
                        "xmlId": "abcaa0f0eaf-2801-42f4-90b0-91db56ebf86e",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 100000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 22,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 22,
                        "femaleAgeMax": 65,
                        "totalPeriod": 6,
                        "employeePeriod": 3,
                        "businessPeriod": 12,
                        "requirements": "Обязательное условие -   страхование недвижимости в пользу банка на срок кредитования. При отсутствии личного страхования заемщика процентная ставка увеличивается на 4%. <br/><br/>• Для ЗП проектов при ПВ от 20% -ставка 8,35%, ПВ от 50% - ставка 8,1%<br/><br/>Список документов:<br/>1) Анкета <br/>2) Паспорт РФ <br/>3) Военный билет для лиц мужского пола <br/>4) Страховое свидетельство государственного пенсионного страхования Заемщика <br/>5) 2НДФЛ или справка по форме банка <br/>6) Заверенная копия ТК<br/><br/>Воспользуйтесь услугой «Снижение ставки», чтобы снизить процент по ипотеке на 0,5% - 1,5%: <br/>1) скидка 0,5% - комиссионное вознаграждение 1,6% от СК <br/>2) скидка 1% - комиссионное вознаграждение 3,2% от СК <br/>3) скидка 1,5% - комиссионное вознаграждение 4,8% от СК",
                        "minPercent": 8.25,
                        "maxPercent": 8.55,
                        "minPeriod": 5,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    }
                ],
                "minPercent": 8.25,
                "maxPeriod": 30,
                "minInitialPayment": 5,
                "formName": "Аккредитация Московский Индустриальный Банк в Солнечный город"
            },
            {
                "id": "11857",
                "logo": {
                    "id": 411006,
                    "src": "/upload/resize_cache/iblock/06d/300_50_140cd750bba9870f18aada2478b24840a/otkrytie.png",
                    "contentType": "image/png",
                    "width": 170,
                    "height": 49,
                    "description": ""
                },
                "name": "Банк ОТКРЫТИЕ",
                "xmlId": "abc35",
                "bankPrograms": [
                    {
                        "id": 1134,
                        "name": "Два документа",
                        "xmlId": "abc8e368d8d-1008-427e-8e86-24f5c24e5b01",
                        "initialPaymentMin": 40,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 15000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Надбавки и скидки к процентной ставке: <br/>1) +0,15% — при сумме кредита менее 6 млн рублей <br/>2) +0,2% — при несоответствии ни одному из критериев<br/>— зарплатный клиент банка<br/>— заявка поступила от партнера банка<br/>— заявка оформлена онлайн <br/>3) +2% — при отсутствии страхования жизни и трудоспособности<br/><br/>Ставка 9,55% cумма кредита — от 6 млн рублей<br/>",
                        "minPercent": 10.05,
                        "maxPercent": 10.05,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1188,
                        "name": "Новостройка",
                        "xmlId": "abcda4ec7a3-0bbb-46ce-9216-99c175bdb93f",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 3,
                        "businessPeriod": 24,
                        "requirements": "Надбавки и скидки к процентной ставке: <br/>1) +0,15% — при сумме кредита менее 6 млн рублей <br/>2) +0,2% — при несоответствии ни одному из критериев<br/>— зарплатный клиент банка<br/>— заявка поступила от партнера банка<br/>— заявка оформлена онлайн <br/>3) +2% — при отсутствии страхования жизни и трудоспособности<br/><br/>Ставка 9,55% cумма кредита — от 6 млн рублей<br/><br/>",
                        "minPercent": 8.85,
                        "maxPercent": 9.55,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    },
                    {
                        "id": 1209,
                        "name": "Военная Ипотека",
                        "xmlId": "abcbde0f4a6-2250-4b56-a9e9-d04a3326f158",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 500000,
                        "creditMax": 2514000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 25,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 25,
                        "femaleAgeMax": 45,
                        "totalPeriod": 12,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Военнослужащий, являющийся участником накопительно-ипотечной системы жилищного обеспечения военнослужащих в соответствии с Федеральным законом от 20.08.2004 № 117-ФЗ «О накопительно-ипотечной системе жилищного обеспечения военнослужащих». Созаемщиков привлекать запрещено. <br/><br/>Список документов:<br/>1) Паспорт РФ <br/>2) Свидетельство о праве участника накопительно-ипотечной системы жилищного обеспечения военнослужащих на получение целевого жилищного займа <br/>3) Свидетельство о браке/о расторжении брака (при наличии).",
                        "minPercent": 9,
                        "maxPercent": 9,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    }
                ],
                "buildings": [
                    {
                        "id": 9416,
                        "name": "корп.9.1",
                        "countApartments": 1,
                        "price": "от 4 250 010 р. до 4 250 010 р.",
                        "minPrice": 4250010,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9417,
                        "name": "корп.9.2",
                        "countApartments": 3,
                        "price": "от 3 100 002 р. до 4 250 010 р.",
                        "minPrice": 3100002,
                        "maxPrice": 4250010
                    },
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9892,
                        "name": "корп.10.3.1",
                        "countApartments": 52,
                        "price": "от 2 850 184 р. до 8 200 526 р.",
                        "minPrice": 2850184,
                        "maxPrice": 8200526
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9894,
                        "name": "корп.10.2.2",
                        "countApartments": 63,
                        "price": "от 2 950 204 р. до 7 000 029 р.",
                        "minPrice": 2950204,
                        "maxPrice": 7000029
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10062,
                        "name": "корп.8.2",
                        "countApartments": 1,
                        "price": "от 3 650 010 р. до 3 650 010 р.",
                        "minPrice": 3650010,
                        "maxPrice": 3650010
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    },
                    {
                        "id": 10734,
                        "name": "корп.13.2",
                        "countApartments": 83,
                        "price": "от 3 100 117 р. до 6 600 250 р.",
                        "minPrice": 3100117,
                        "maxPrice": 6600250
                    },
                    {
                        "id": 10735,
                        "name": "корп.13.1",
                        "countApartments": 23,
                        "price": "от 3 100 129 р. до 11 900 643 р.",
                        "minPrice": 3100129,
                        "maxPrice": 11900643
                    },
                    {
                        "id": 10764,
                        "name": "корп.15",
                        "countApartments": 31,
                        "price": "от 3 098 801 р. до 6 500 404 р.",
                        "minPrice": 3098801,
                        "maxPrice": 6500404
                    }
                ],
                "minPercent": 8.85,
                "maxPeriod": 30,
                "minInitialPayment": 25,
                "formName": "Аккредитация Банк ОТКРЫТИЕ в Солнечный город"
            },
            {
                "id": "11873",
                "logo": false,
                "name": "",
                "xmlId": "abc40",
                "bankPrograms": [
                    {
                        "id": 1183,
                        "name": "Военная ипотека",
                        "xmlId": "abca2cb6ab2-85c6-4a26-8a45-924026f687d3",
                        "initialPaymentMin": 20,
                        "initialPaymentMax": 80,
                        "creditMin": 400000,
                        "creditMax": 2765000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 45,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 45,
                        "totalPeriod": 36,
                        "employeePeriod": 36,
                        "businessPeriod": 0,
                        "requirements": "Согласно данной программе военнослужащий – участник НИС (накопительно-ипотечной системы) может приобрести недвижимость с использованием ипотечного кредита через 3 года после вступления в НИС.<br/><br/>Документы:<br/>• паспорт РФ<br/>• свидетельство НИС<br/>• анкета и кредитная заявка по форме Банка<br/><br/>Значение максимальной суммы кредита определяется таким образом, чтобы общей суммы взносов, которая должна накопиться на счете военнослужащего – участника НИС до достижения им 45 лет, было бы достаточно для полного погашения кредита и процентов по нему.<br/>",
                        "minPercent": 9.1,
                        "maxPercent": 9.1,
                        "minPeriod": 20,
                        "maxPeriod": 20
                    },
                    {
                        "id": 1223,
                        "name": "Новостройка",
                        "xmlId": "abc55f20a0d-c629-40c6-ba5b-f3dc5e2f7803",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 400000,
                        "creditMax": 30000000,
                        "reviewPeriod": 5,
                        "maleAgeMin": 21,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 21,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 4,
                        "businessPeriod": 12,
                        "requirements": "Место регистрации:<br/>• в любом регионе РФ<br/><br/>! ИП не кредитует<br/><br/>Доходы:<br/>• официально подтвержденные доходы от работы по найму (2-НДФЛ)<br/>• доходы, подтвержденные справкой по форме Банка<br/>• пенсия<br/> <br/>Надбавки к ставкам: 1) Без оформления личного страхования на момент подписания кредитного договора процентная ставка повысится на 1.0 процентный пункт. 2) Без оформления титульного страхования на момент подписания кредитного договора процентная ставка повысится на 1.0 процентный пункт.<br/><br/>Для зп клинетов ставка 9,2%",
                        "minPercent": 9.7,
                        "maxPercent": 9.7,
                        "minPeriod": 30,
                        "maxPeriod": 30
                    }
                ],
                "buildings": [],
                "minPercent": 9.1,
                "maxPeriod": 30,
                "minInitialPayment": 20,
                "formName": "Аккредитация  в Солнечный город"
            },
            {
                "id": "11874",
                "logo": {
                    "id": 411038,
                    "src": "/upload/resize_cache/iblock/e46/300_50_140cd750bba9870f18aada2478b24840a/4fc1b1f167b42f070defc7b7d0ad232d.jpg",
                    "contentType": "image/jpeg",
                    "width": 203,
                    "height": 50,
                    "description": ""
                },
                "name": "СМП Банк",
                "xmlId": "abc85",
                "bankPrograms": [
                    {
                        "id": 1128,
                        "name": "Ипотека без ПВ",
                        "xmlId": "abc25c11898-345f-4ff7-83e7-0a7b728b65f3",
                        "initialPaymentMin": 0,
                        "initialPaymentMax": 14,
                        "creditMin": 400000,
                        "creditMax": 15000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 6,
                        "employeePeriod": 12,
                        "businessPeriod": 24,
                        "requirements": "Скидки и надбавки к процентной ставке: <br/>1) Для клиентов, не оформляющих личное страхование, процентная ставка увеличивается на 2 процентных пункта. <br/>2) При запрете клиентом уступки прав требования по кредитному договору процентная ставка увеличивается на 1 процентный пункт. <br/>3) При достижении коэффициента Кредит/Залог ниже 85% в период действия кредитного договора размер процентной ставки может быть снижен на 2 процентных пункта на основании письменного заявления клиента.<br/><br/>Список док-ов: <br/>1. Заявление-анкета<br/>2. Паспорт гражданина РФ. <br/>3. Документы, подтверждающие доход и занятость (копия ТК и справка о ЗП). <br/>4. Документы, подтверждающие семейный статус.<br/>5. Свидетельство о перемене имени/ фамилии/ отчества (если применимо).<br/>6. Военный билет для лиц мужского пола призывного возраста либо справка, содержащаясведения о прохождении службы, стажа и занимаемой должности – для работников МВД и МЧС.<br/>7. Документы, предоставляемые по действующим кредитам ",
                        "minPercent": 14,
                        "maxPercent": 14,
                        "minPeriod": 10,
                        "maxPeriod": 10
                    },
                    {
                        "id": 1141,
                        "name": "Акция 9,99%",
                        "xmlId": "abc26b21eec-c9ad-48ca-bc21-2b330be13898",
                        "initialPaymentMin": 50,
                        "initialPaymentMax": 80,
                        "creditMin": 4000000,
                        "creditMax": 30000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": " Для индивидуальных предпринимателей – срок регистрации ИП должен составлять не менее 24 месяцев до даты обращения в Банк. Для владельцев/совладельцев бизнеса – срок регистрации юридического лица должен составлять не менее 12 месяцев до даты обращения в Банк. <br/><br/>Список документов: <br/>1) Заявление-анкета <br/>2) Паспорт РФ <br/>3) Документы, подтверждающие доход и занятость (копия ТК и справка) <br/>4) Документ, подтверждающий семейный статус <br/>5) Свидетельство о перемене имени/ фамилии/ отчества (если применимо) <br/>6)Военный билет для лиц мужского пола призывного возраста. Для работников МВД и МЧС - справка, содержащая сведения о прохождении службы, стажа и занимаемой должности. <br/><br/>Надбавки к ставке<br/>1) Для клиентов, не оформляющих личное страхование, процентная ставка увеличивается на 2 процентных пункта.<br/>2) При запрете клиентом уступки прав требования по кредитному договору процентная ставка увеличивается на 1 процентный пункт. 3) До регистрации права собственности процентная ставка увеличивается на 1 процентный пункт.",
                        "minPercent": 9.99,
                        "maxPercent": 9.99,
                        "minPeriod": 15,
                        "maxPeriod": 15
                    },
                    {
                        "id": 1143,
                        "name": "Новостройка",
                        "xmlId": "abc74208d3a-cda9-4adc-af1f-2c6985d2d868",
                        "initialPaymentMin": 15,
                        "initialPaymentMax": 90,
                        "creditMin": 400000,
                        "creditMax": 30000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": " Для индивидуальных предпринимателей – срок регистрации ИП должен составлять не менее 24 месяцев до даты обращения в Банк. Для владельцев/совладельцев бизнеса – срок регистрации юридического лица должен составлять не менее 12 месяцев до даты обращения в Банк. <br/><br/>Список документов: <br/>1) Заявление-анкета <br/>2) Паспорт РФ <br/>3) Документы, подтверждающие доход и занятость (копия ТК и справка)<br/>4) Документ, подтверждающий семейный статус <br/>5) Свидетельство о перемене имени/ фамилии/ отчества (если применимо) 6)Военный билет для лиц мужского пола призывного возраста. <br/>Для работников МВД и МЧС - справка, содержащая сведения о прохождении службы, стажа и занимаемой должности.<br/><br/> При использовании средств материнского (семейного) капитала размер собственных средства заемщика может составлять от 10% от стоимости недвижимости.  <br/><br/>Категория клиента «Льготные» :  ПВ от 15% -  ставка 10,9%., ПВ от 20% - ставка 10,6%.<br/><br/>Надбавки к ставке: <br/>1) Для клиентов, не оформляющих личное страхование, процентная ставка увеличивается на 2 процентных пункта.<br/>2) При запрете клиентом уступки прав требования по кредитному договору процентная ставка увеличивается на 1 процентный пункт. <br/>3) До регистрации права собственности процентная ставка увеличивается на 1 процентный пункт.",
                        "minPercent": 10.9,
                        "maxPercent": 11.2,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    },
                    {
                        "id": 1186,
                        "name": "Новостройка 2 док-та",
                        "xmlId": "abcd93997da-17ac-47ad-abbf-95e0e1f9c608",
                        "initialPaymentMin": 40,
                        "initialPaymentMax": 90,
                        "creditMin": 400000,
                        "creditMax": 30000000,
                        "reviewPeriod": 10,
                        "maleAgeMin": 18,
                        "maleAgeMax": 65,
                        "femaleAgeMin": 18,
                        "femaleAgeMax": 65,
                        "totalPeriod": 12,
                        "employeePeriod": 6,
                        "businessPeriod": 24,
                        "requirements": " Надбавки: 1) Для клиентов, не оформляющих личное страхование, процентная ставка увеличивается на 2 процентных пункта. 2) При запрете клиентом уступки прав требования по кредитному договору процентная ставка увеличивается на 1 процентный пункт. 3) До регистрации права собственности процентная ставка увеличивается на 1 процентный пункт.<br/><br/>Для индивидуальных предпринимателей – срок регистрации ИП должен составлять не менее 24 месяцев до даты обращения в Банк. <br/>Для владельцев/совладельцев бизнеса – срок регистрации юридического лица должен составлять не менее 12 месяцев до даты обращения в Банк. <br/><br/>• Доп условие - Строительная готовность новостройки не менее 50% (по этажам).<br/><br/> Документы: <br/>1) заявление <br/>2) паспорт РФ <br/>3) СНИЛС. <br/><br/>• Категория клиента «Льготные» - ставка 12,2%",
                        "minPercent": 12.7,
                        "maxPercent": 12.7,
                        "minPeriod": 25,
                        "maxPeriod": 25
                    }
                ],
                "buildings": [
                    {
                        "id": 9757,
                        "name": "корп.10.2",
                        "countApartments": 1,
                        "price": "от 7 299 993 р. до 7 299 993 р.",
                        "minPrice": 7299993,
                        "maxPrice": 7299993
                    },
                    {
                        "id": 9766,
                        "name": "корп.10.1",
                        "countApartments": 18,
                        "price": "от 3 000 023 р. до 8 700 588 р.",
                        "minPrice": 3000023,
                        "maxPrice": 8700588
                    },
                    {
                        "id": 9878,
                        "name": "корп.10.1.1",
                        "countApartments": 27,
                        "price": "от 3 100 158 р. до 11 000 149 р.",
                        "minPrice": 3100158,
                        "maxPrice": 11000149
                    },
                    {
                        "id": 9879,
                        "name": "корп.10.1.2",
                        "countApartments": 5,
                        "price": "от 3 100 129 р. до 6 300 066 р.",
                        "minPrice": 3100129,
                        "maxPrice": 6300066
                    },
                    {
                        "id": 9893,
                        "name": "корп.10.2.1",
                        "countApartments": 8,
                        "price": "от 3 500 170 р. до 9 000 563 р.",
                        "minPrice": 3500170,
                        "maxPrice": 9000563
                    },
                    {
                        "id": 9897,
                        "name": "корп.10.1.3",
                        "countApartments": 13,
                        "price": "от 3 000 120 р. до 7 000 374 р.",
                        "minPrice": 3000120,
                        "maxPrice": 7000374
                    },
                    {
                        "id": 10073,
                        "name": "корп.11.1",
                        "countApartments": 68,
                        "price": "от 3 500 081 р. до 6 950 076 р.",
                        "minPrice": 3500081,
                        "maxPrice": 6950076
                    },
                    {
                        "id": 10074,
                        "name": "корп.11.3",
                        "countApartments": 33,
                        "price": "от 3 500 165 р. до 7 450 435 р.",
                        "minPrice": 3500165,
                        "maxPrice": 7450435
                    },
                    {
                        "id": 10079,
                        "name": "корп.11.4",
                        "countApartments": 4,
                        "price": "от 3 850 143 р. до 4 449 997 р.",
                        "minPrice": 3850143,
                        "maxPrice": 4449997
                    },
                    {
                        "id": 10691,
                        "name": "корп.10.3.2",
                        "countApartments": 9,
                        "price": "от 3 500 101 р. до 7 000 120 р.",
                        "minPrice": 3500101,
                        "maxPrice": 7000120
                    },
                    {
                        "id": 10707,
                        "name": "корп.12.1",
                        "countApartments": 14,
                        "price": "от 4 050 078 р. до 12 000 100 р.",
                        "minPrice": 4050078,
                        "maxPrice": 12000100
                    },
                    {
                        "id": 10708,
                        "name": "корп.12.2",
                        "countApartments": 13,
                        "price": "от 3 600 094 р. до 6 450 433 р.",
                        "minPrice": 3600094,
                        "maxPrice": 6450433
                    }
                ],
                "minPercent": 9.99,
                "maxPeriod": 25,
                "minInitialPayment": 10,
                "formName": "Аккредитация СМП Банк в Солнечный город"
            }
        ]
    },
    "blockId": 13960,
    "blockName": "Солнечный город",
    "builder": {
        "id": 11578,
        "name": "SetlCity",
        "typical3DTour": ""
    },
    "builderId": 11578,
    "builderName": "SetlCity",
    "region": {
        "id": 206,
        "name": "Красносельский р-н"
    },
    "encumbranceDescription": "",
    "city": "len",
    "infrastructure": {
        "id": 159479,
        "src": "/upload/iblock/382/Безымянный.png",
        "contentType": "image/png",
        "width": 760,
        "height": 420,
        "description": "",
        "fileSize": 96861
    },
    "coordinates": [
        59.840168459056,
        30.113316677143
    ],
    "address": "Санкт-Петербург г., Петергофское ш.",
    "cityCode": "len",
    "cityId": 2,
    "corpus": "8.1 корп.",
    "endingDate": "IV кв. 2019",
    "presentation": {
        "id": 61904
    }
};
